import { CaseProps } from "../types/CaseProps";

const Cases:  CaseProps[] = [
  {
    caseid: "o-1",
    sessionid:"001",
    title: "10：35〜11：45　口演①　［ 肝臓 ］（演題O-1〜O-3）",
    casetitle: "O-01   診断に苦慮した巨大肝腫瘍",
    reader:"川⼝ 雅彦（横浜栄共済病院 外科）",
    members: `○川⼝ 雅彦<sup>1）</sup>、山岸 豊<sup>1）</sup>、南川 友理<sup>1）</sup>、木村 花梨<sup>1）</sup>、東 弘太郎<sup>1）</sup>、加藤 秀明<sup>1）</sup>、谷⼝ 桂三<sup>1）</sup>、渡邊 透<sup>1）</sup>、廣石 篤司<sup>2）</sup>、岸 宏久<sup>3）</sup>
    1）横浜栄共済病院 外科、2）横浜栄共済病院 放射線科、
    3）横浜栄共済病院 病理科
`,
    detail: `　症例は 45 歳女性で検診の腹部超音波検査で肝右葉に腫瘍を認め当院紹介となった。既往歴なし、
    内服歴なし。喫煙はせず、飲酒は ビール 350mL と緑茶ハイ 2 杯程度。家族歴は特記すべきことなし。
    HBｓAg(-), HCV-II (-), AFP 6 ng/mL, CEA 0.9 ng/mL, CA19-9 8 U/mL, CA125 16 U/mL。
    身長 164.1cm 体重 53.3kg BMI 19.8。ICG 15 4.4, Child-Pugh: A(5 点 )。
    造影 CT 検査では、肝右葉を占拠する 10cm 大の腫瘤を認めた。造影早期では中央部分を除き濃染、腫瘍周囲および内部にも腫瘍血管を認めた。平衡相に行くに従い腫瘍は一部をのぞき全体に濃染した。
     MRI では、T1 強調像上低信号、T2 強調像上不均一な淡い高信号、拡散強調像上軽度高信号、ADC map 低信号、dynamic 造影早期に中心部分以外は強く濃染、後期相で中心部分も含めてほとんどが濃染し、肝細胞相で低信号を示した。CoCC 混合型 HCC 血管肉腫等を疑い、肝右葉切除術を施行した。腫瘍は薄い被膜を伴う黄白色の充実性腫瘤であった。
     病理組織学的診断は、鑑別として (1) solitary fibrous tumor (SFT) (2) Inflammatory myōfibroblastic tumor (IMT)(3) Inflammatory Rseudotumor (IPT) (4) Follicular dendritic cell tumor (FDCT) (5) Leiomyoma (LM) が挙げられ、最終的に Primary benign mesenchymal tumor most likely to be inflammatory myofibroblastic tumor とした。
術前画像診断および病理組織学的診断についてご討議いただきたい。`,
    link: "/case/o-1",
    dicomlink: [
    "https://app.lookrec.com/viewer/v2/consulting/viewer?t=MTIxZTZhZWFiZDU0MWQzYTRjZDMzMDJkYjM1NTk5MGRmMjYzNzNhMTNlMWEzNzQyZWU5ZDdiZjAzMTc2MjUzYg==&published=1",
  ]
  },
  {
    caseid: "o-2",
    sessionid:"002",
    title: "10：35〜11：45　口演①　［ 肝臓 ］（演題O-1〜O-3）",
    casetitle: "O-02   検診USにて発見された多発肝腫瘤の1例",
    reader:"森田　翔一（独立行政法人JCHO四日市羽津医療センター消化器内科）",
    members: `○森田 翔一、中島 滋人、面谷 卓馬、宮尾 遼、青田 紗季<sup>）</sup>、阪⼝ 亮平、坪井 順哉、樋⼝ 国博、長谷川 浩司
    独立行政法人 JCHO 四日市羽津医療センター 消化器内科`,
    detail: `　症例は 50 代女性。US にて肝に境界不明瞭な多発する低エコー性腫瘤を指摘され当科受診。発熱・腹痛
等自覚症状はなく、理学的所見も右季肋部に肝を 1 横指触知する以外に特記所見は認めなかった。CT にて
肝全体に多発する境界不明瞭な星佄状の低濃度結節所見を認めた。MRI では腫瘤部は T1 強調像で淡い低
信号、T2 強調像で淡い高信号を呈していた。また PET では腫瘤部に一致した強い集積所見を認めた。そ
の他右肺細気管支粒状影と肝門部リンパ節・右外腸骨リンパ節腫大・脾腫を認め、採血にて軽度の肝胆道
系酵素上昇、LDH 上昇、可溶性 IL-2 レセプターの上昇を認めた。以上より肝原発悪性リンパ腫を疑い US
下肝生検を施行したところ、壊死のない多核巨細胞を伴った類上皮肉芽腫を認めた。その後、鑑別すべき
真菌・結核菌・非定型抗酸菌症等の感染症や原発性胆汁性胆管炎等が否定され、肝サルコイドーシスと最
終診断した。肝サルコイドーシスの画像所見は、一般的には門脈域に沿った境界の比較的明瞭な類円形の
多発結節とされている。本症例は各画像とも非常に特徴的な所見を認め大変興味深いと考えられた。希少
性があれば当研究会でご検討頂き、共有出来ればと思います。`,
    link: "/case/o-2",
    dicomlink: ["https://app.lookrec.com/viewer/v2/consulting/viewer?t=NmQ0NThhNDgzNTBmMTMyMDZmMGE1Y2Q4NDk4Mjg5NGNjMzZlODc2NjYxN2QxMGNmYjVmMjUwNGNlMjdhNGZjOA==&published=1",
      "https://app.lookrec.com/viewer/v2/consulting/viewer?t=ZTE3NTBmMDhjNTM3M2E4NjI0ODBkZjU3MDJlY2U3MDQ1OWU4ZWEwMDIzYWRiMWNmMzM3YmEyMWUxZjA3NWI3Yg==&published=1"]
  },
  {
    caseid: "o-3",
    sessionid:"003",
    title: "10：35〜11：45　口演①　［ 肝臓 ］（演題O-1〜O-3）",
    casetitle: "O-03   胆管穿破を伴った肝内IPNB由来浸潤癌の1例",
    reader:"池谷　桃子（医学研究所北野病院　消化器内科）",
    members: `○池谷 桃子<sup>1）</sup>、大沢 一希<sup>1）</sup>、岩野 光佑<sup>1）</sup>、森田 敏広<sup>1）</sup>、八隅 秀二郎<sup>1）</sup>、仲野 健三<sup>2）</sup>、
井⼝ 公太<sup>2）</sup>、田浦 康二朗<sup>2）</sup>、寺嶋 宏明<sup>2）</sup>、本庄 原<sup>3）</sup>
1）医学研究所北野病院 消化器内科、2）医学研究所北野病院 消化器外科、
3）医学研究所北野病院 病理診断科`,
    detail: `　症例は 81 歳男性。左上腹部痛と発熱を主訴に近医を受診し、腹部エコーで肝腫瘤を指摘されたため当院紹介となった。造影 CT では、肝左葉に辺縁不整・内部不均一で辺縁に若干の造影効果を呈する低吸収な90mm 大の腫瘤を認めた。また、胃穹窿部～小弯の壁肥厚と周囲の液貯留を認めた。MRI では腫瘤は隔壁構造を有し、T1 強調画像では低信号、T2 強調画像では大部分が高信号を呈したが、拡散制限は認めなかった。
MRCP では左肝内胆管の拡張を認め、拡張した B3 胆管と腫瘤の交通があることから、IPNB が疑われた。 ERCPを行うと、胆管造影では B3 胆管と連続した腔を認めたが、内容液は吸引できなかった。IDUS では B2/3胆管根部まで低エコーの内容物が充満し、左右肝管合流部付近まで連続した壁肥厚を認めた。また、 ERCP後の腹部 X 線検査で B2 胆管付近から連続する肝外造影剤漏出を認め、胃周囲の液貯留の所見と合わせ、胆管穿破・胆汁瘻を合併していると判断した。炎症改善後に左右肝管分岐部・肝門部胆管・遠位胆管の陰性生検を確認後、肝左葉切除＋リンパ節郭清術を施行した。
病理診断は、病変の大部分で粘液癌の像を示し、一部に粘液貯留を伴う胆管内乳頭状成分を認め、IPMB 由来浸潤癌の診断となった。術前画像では豊富な粘液成分が示唆されたが、ERCP での粘液吸引や術前診断は困難で、病理の肉眼像も充実性腫瘍様であった。画像所見と病理所見の乖離について説明可能か議論いただきたい。`,
    link: "/case/o-3",
    dicomlink: ["https://app.lookrec.com/viewer/v2/consulting/viewer?t=ZWY0N2FkOWJhY2NmYzg1N2E3NjcxMGI4ZWQ4YWZjNmFhNTI2ZWFmNmE3YzBhMjQ3MTU0MGIyYTM3ZGMzNzExNQ==&published=1"]
  },
  {
    caseid: "o-4",
    sessionid:"004",
    title: "13：15〜14：25　口演②　［ 胆道 ］（演題O-4〜O-6）",
    casetitle: "O-04   術前診断に苦慮した門脈内進展を伴うIPNB(type1)の1例",
    reader:"生駒　一平（順天堂大学医学部附属順天堂医院消化器内科）",
    members: `○生駒 一平<sup>1）</sup>、冨嶋 享<sup>1）</sup>、佐野 勝廣<sup>2）</sup>、福村 由紀<sup>3）</sup>、髙橋 翔<sup>1）</sup>、髙﨑 祐介<sup>1）</sup>、
倉田 芙美<sup>1）</sup>、石井 重登<sup>1）</sup>、藤澤 聡郎<sup>1）</sup>、伊佐山 浩通<sup>1）</sup>
1）順天堂大学医学部附属順天堂医院 消化器内科、2）順天堂大学医学部附属順天堂医院 放射線科、
3）順天堂大学医学部附属順天堂医院 体病理病態学講座`,
    detail: `　症例は 81 歳男性。左上腹部痛と発熱を主訴に近医を受診し、腹部エコーで肝腫瘤を指摘されたため当院
紹介となった。造影 CT では、肝左葉に辺縁不整・内部不均一で辺縁に若干の造影効果を呈する低吸収な
90mm 大の腫瘤を認めた。また、胃穹窿部～小弯の壁肥厚と周囲の液貯留を認めた。
MRI では腫瘤は隔壁構造を有し、T1 強調画像では低信号、T2 強調画像では大部分が高信号を呈したが、拡散制限は認めなかった。
MRCP では左肝内胆管の拡張を認め、拡張した B3 胆管と腫瘤の交通があることから、IPNB が疑われた。 
ERCPを行うと、胆管造影では B3 胆管と連続した腔を認めたが、内容液は吸引できなかった。IDUS では B2/3胆管根部まで低エコーの内容物が充満し、左右肝管合流部付近まで連続した壁肥厚を認めた。
また、 ERCP後の腹部 X 線検査で B2 胆管付近から連続する肝外造影剤漏出を認め、胃周囲の液貯留の所見と合わせ、胆管穿破・胆汁瘻を合併していると判断した。炎症改善後に左右肝管分岐部・肝門部胆管・遠位胆管の陰性生検を確認後、肝左葉切除＋リンパ節郭清術を施行した。
病理診断は、病変の大部分で粘液癌の像を示し、一部に粘液貯留を伴う胆管内乳頭状成分を認め、IPMB 由来浸潤癌の診断となった。術前画像では豊富な粘液成分が示唆されたが、ERCP での粘液吸引や術前診断は困難で、病理の肉眼像も充実性腫瘍様であった。画像所見と病理所見の乖離について説明可能か議論いただきたい。`,
    link: "/case/o-4",
    dicomlink: ["https://app.lookrec.com/viewer/v2/consulting/viewer?t=ODY2NTI2NDZkZWY1MWIzYmNmZWM3ZmZjY2ZmNzNlNzczMjM3M2VmOGRhODJmM2YwYWE1YTdiNmZkNGFhMmFmYQ==&published=1",
      "https://app.lookrec.com/viewer/v2/consulting/viewer?t=Y2VlYTFjYjNhNTQ2M2FlOTExMGQ5M2Y1OWM4Y2E3NjI5MmVjZThkMTI0NjliZDRmNzFlYTdmMWQ5ZTUyM2RjMw==&published=1"]
  },
  {
    caseid: "o-5",
    sessionid:"005",
    title: "13：15〜14：25　口演②　［ 胆道 ］（演題O-4〜O-6）",
    casetitle: "O-05   胆管周囲付属腺から発生したと考える IPNB の胆管内進展を経時的に観察し得た一例",
    reader:"本多　悠（横浜市立大学附属病院　肝胆膵消化器病学）",
    members: `○本多 悠<sup>1）</sup>、八木 伸<sup>1）</sup>、栗田 裕介<sup>1）</sup>、長谷川 翔<sup>1）</sup>、佐藤 高光<sup>2）</sup>、小池 千尋<sup>3）</sup>、
山中 正二<sup>3）</sup>、遠藤 格<sup>4）</sup>、米田 正人<sup>1）</sup>、窪田 賢輔<sup>1）</sup>
1）横浜市立大学附属病院 肝胆膵消化器病学、2）茅ケ崎市立病院 消化器内科、
3）横浜市立大学附属病院 病理診断科、4）横浜市立大学附属病院 消化器腫瘍外科`,
    detail: `　症例は 53 歳男性．検診で肝門部近傍の嚢胞性病変が指摘され，当院に紹介となった．造影 CT では肝門
部近傍に 15mm 程度の嚢胞状の低濃度腫瘤があり，内部には一部造影効果を認めた．EUS では嚢胞性病変
は内部に充実成分を伴い，一部総胆管と接触していた．胆管内乳頭状腫瘍（IPNB）を疑い ERCP を施行し
たが，胆管造影では胆管壁に不整は認めなかった．経口胆道鏡（POCS）では，肝門部の胆管上皮に異常は
なく，嚢胞性病変との交通は確認できなかった．胆汁細胞診でも腫瘍細胞は認めず，PET-CT でも有意な集
積はなく，画像フォローの方針とした．初診から 3 年目の CT 検査で病変は軽度増大傾向で，EUS では嚢
胞性病変内部の充実成分の胆管への進展が疑われた．再度 ERCP・POCS を施行すると，胆管造影で肝門部
胆管壁に軽度の不整と，胆管外に嚢状に造影される部位を認めた．POCS では肝門部胆管から右肝管に連続
する乳頭状の腫瘤を認めた．POCS 下での腫瘍生検では腺癌を認め，IPNB 由来の胆管癌の術前診断で，肝
前区域尾状葉切除を施行した．手術検体では，病変部に粘液を豊富に含む細胞質を有する円柱状上皮が乳
頭状・管状に増殖し，一部に不規則な乳頭状構造や癒合状腺管の形成と核異型を認め，IPNB を由来とした
管状腺癌と診断した．本症例は初診時に胆管内腔に病変はなく，胆管周囲付属腺から発生した IPNB が胆管
内進展した症例と考えた．胆管周囲付属腺が病変の主座でよいかご討議いただきたい．`,
    link: "/case/o-5",
    dicomlink: ["https://app.lookrec.com/viewer/v2/consulting/viewer?t=NDZiODc2ODFmNzUxNWI3NGIyYWJiZmYwNmM3MDFiNzRjNjE1OWQ1MGJlNTgxM2NiYzNhNjRhMTM2ODc2MzAxZg==&published=1"]
  },
  {
    caseid: "o-6",
    sessionid:"006",
    title: "13：15〜14：25　口演②　［ 胆道 ］（演題O-4〜O-6）",
    casetitle: "O-06   胆管内に腫瘤を形成したIgG4 関連硬化性胆管炎の 1 例",
    reader:"外園　友之（福岡大学筑紫病院消化器内科）",
    members: `○外園 友之、丸尾 達、中島 美紀、江崎 薫、後野 徹宏、松岡 大介、平塚 裕晃、立川 勝子、永山 林太郎、野間 栄次郎
福岡大学筑紫病院 消化器内科`,
    detail: `　70 代男性 . 血液検査でγ -GT 高値のため施行した腹部超音波検査で右肝内胆管の拡張を指摘され , 紹介
となった . 血液検査所見では , 肝胆道系酵素は上昇（AST：39 U/L, ALT：39 U/L, γ -GT：1258 U/L）
していたが , 腫瘍マーカーは正常範囲内（CEA：2.4 ng/mL, CA19-9：30.8 U/mL）で , IgG は 1834 mg/dL,
IgG4 は 106 mg/dL であった . 腹部超音波検査では , 右肝内胆管は拡張していたが , 腫瘤はなかった . 造影
CT（Dynamic CT）では , 右肝管起始部に狭窄があったが腫瘤は指摘できなかった . MRCP では , 右肝管起始部が狭窄しておりDWI で淡い高信号, ADC-map 高値であり拡散制限はなかった. 超音波内視鏡検査では,右肝内胆管内に乳頭状に発育した腫瘤性病変を認め , 腫瘤より肝側の末梢胆管は拡張していた . ERCP の胆管造影では , MRCP 同様 , 右肝管起始部に狭窄を認めたため , 狭窄部の透視下生検を行ったところ , 線維化間質と変性した組織を認めたが悪性所見はなかった . 経口胆道鏡検査では , 右肝内胆管起始部の胆管内に表面平滑な腫瘤があり , 胆道鏡下に生検を行った . 組織学的には , 形質細胞浸潤および中等度の線維化があり ,免疫染色では抗 IgG4 抗体陽性の形質細胞を多数（70 /HPF）認めたため , 胆管内に腫瘤を形成した IgG4関連硬化性胆管炎と診断した. 診断後1 年 4 ヶ月, 外来で経過観察を行っているが, 著変なく経過している.
【討論のポイント】生検前の画像所見で IgG4 関連硬化性胆管炎を疑う所見があったか .`,
    link: "/case/o-6",
    dicomlink: ["https://app.lookrec.com/viewer/v2/consulting/viewer?t=MzE2ZDM2NWFjYTg0MWE5ODY2MDQ0NGNjYTE0OWZkOTZkMmZlYmVhMzY4ZWY1NDcyNjg2MWRiY2I3MTY1NzE0OA==&published=1"]
  },
  {
    caseid: "pl-1",
    sessionid:"007",
    title: "14：35〜16：05　プレナリーセッション1　［ 教育的・典型的症例 ］(演題PL-1〜PL-3）",
    casetitle: "PL-1   主膵管狭窄と貯留嚢胞を契機に診断しえた High-grade PanIN の一例",
    reader:"辻　博晶（大分三愛メディカルセンター消化器内科）",
    members: `○辻 博晶<sup>1）</sup>、佐上 亮太<sup>2）</sup>、錦織 英史<sup>1）</sup>、佐藤 孝生<sup>1）</sup>、佐藤 啓司<sup>3）</sup>、小山 雄三<sup>3）</sup>、藤原 省三<sup>4）</sup>、本田 五郎<sup>5）</sup>、水上 一弘<sup>2）</sup>、村上 和成<sup>2）</sup>
1）大分三愛メディカルセンター 消化器内科、2）大分大学医学部 消化器内科学講座、
3）大分三愛メディカルセンター 病理診断部、4）大分三愛メディカルセンター 消化器外科、
5）東京女子医科大学消化器病センター 肝胆膵外科
`,
    detail: `　症例は 76 歳男性．X-19 年前から膵頭部脂肪腫疑いの病変に対して定期画像検査を行われていた．
X-6 年から膵体部主膵管狭窄と近傍の貯留嚢胞が出現し、X-2 年より膵頭部側へ主膵管狭窄の進行と貯留
嚢胞の増大を認めた . この際に SPACE を提案するが、患者希望で経過観察となった . X 年には狭窄部尾側
の膵管拡張も認めた . 造影 CT 検査では膵管狭窄部周囲でのわずかに限局性膵萎縮を認めた . 血液検査では
糖尿病増悪なく、腫瘍マーカーも上昇を認めなかった．超音波内視鏡検査では貯留嚢胞の手前で主膵管狭
窄部を認めるが，周囲に低エコー像は認めなかった．再度患者に説明し、X-3 か月で SPACE を実施した .
ERP 中検体で Class IIIb、SPACE 検体 5/6 回で Class IIIb であり、High-grade PanIN と診断し、腹腔鏡下膵
体尾部切除を実施した . 切除標本では主膵管狭窄部の近傍に貯留嚢胞が散在しており、病理切片でも狭窄周
囲の膵実質萎縮を認めた。貯留嚢胞より頭側部位で丈は低いが核の異型の強い High-grade PanIN 部分を認め、low-grade PanIN は広く分布していた。術前の画像診断で狭窄部位を認めた部分よりも尾側部分の貯留嚢胞内に High-grade PanIN を認めていた点について、経時的な術前画像と術後の病理の評価について検討頂けますと幸いです。`,
    link: "/case/pl-1",
    dicomlink: ["https://app.lookrec.com/viewer/v2/consulting/viewer?t=YjdhMzk2MmI4NTY3NmIzMTRkYzI0YjhjMTU5YTE5NTQ0MzMzZjRiODA5YzdhOWU1ZjE4N2VlNDZlYWZjNWU4Ng==&published=1"]
  },
  {
    caseid: "pl-2",
    sessionid:"008",
    title: "14：35〜16：05　プレナリーセッション1　［ 教育的・典型的症例 ］(演題PL-1〜PL-3）",
    casetitle: "PL-2   経時的に進行する限局性膵萎縮と微小嚢胞の増加から診断に至った微小な浸潤性膵管癌の1 例",
    reader:"川本　裕介（東京女子医科大学　消化器・一般外科）",
    members: `○川本 裕介<sup>1）</sup>、本田 五郎<sup>1）</sup>、山中 良輔<sup>1）</sup>、菊山 正隆<sup>2）</sup>、高山 敬子<sup>2）</sup>、伊藤 泰斗<sup>3）</sup>、古川 徹<sup>3）</sup>
1）東京女子医科大学 消化器・一般外科、2）東京女子医科大学 消化器内科、
3）東北大学大学院 医学系研究科病態病理学分野
`,
    detail: `　症例は 70 歳代、女性。17 年前に他疾患の精査のために撮像した MRI で膵嚢胞を指摘され、以降、主に
腹部超音波検査でフォローされていた。経時的に嚢胞の一部が増大し、膵頭部に微小な嚢胞が出現、増加
してきたことから１年前に当院の消化器内科に紹介となった。MRI、CT では、膵頭部を中心に分枝膵管の
拡張と思われる線形および円形の嚢胞性病変を多数認め、これらの嚢胞性病変と一致して膵頭部から特に
膵頸部で限局的に強い膵実質の委縮を認めた。過去の画像所見と比較すると、長い経過の中でこれらの所
見は緩徐に進行していた。限局性膵萎縮や微小嚢胞は膵尾部にも認めた一方、明らかな主膵管の狭窄や不
整は認めなかった。EUS では、膵頭部に嚢胞状の分枝拡張、膵体尾部に線状高エコーと散在性の低エコー
域を認めたが、明らかな腫瘤は指摘できなかった。以上より早期膵癌の存在を疑い、連続膵液細胞診のた
めに ERP を施行したが、乳頭直下の主膵管のループ形成が高度であったためチューブは留置できず、単回
の膵液細胞診の結果は low-grade PanIN 相当の評価であった。病理学的な確証は得られなかったが画像所
見からは PanIN 病変が疑われたことから、十分な病状説明の上膵全摘を施行した。病理検査の結果、膵頭
部から膵体部にかけて 65mm に渡って非連続性に広がる High-grade PanIN 病変の広がりを認め、一部に膵管壁の破壊と粘液漏出が認められる部位があり、微小浸潤（浸潤性膵管癌）と診断した。`,
    link: "/case/pl-2",
    dicomlink: ["https://app.lookrec.com/viewer/v2/consulting/viewer?t=ZGY4MDAwZTQ1NjRhYmFjZTg3YWRjZGZkM2JhZmI4ZmI3MTVlYTliMTcxMzUyYzk2YmFjOGRiMGE5ZjAwODYzYQ==&published=1"]
  },
  {
    caseid: "pl-3",
    sessionid:"009",
    title: "14：35〜16：05　プレナリーセッション1　［ 教育的・典型的症例 ］(演題PL-1〜PL-3）",
    casetitle: "PL-3   微小浸潤を伴ったT1a膵癌の1例",
    reader:"浅野　響子（東京医科大学　臨床医学系消化器内科学分野）",
    members: `○浅野 響子、土屋 貴愛、田中 麗奈、殿塚 亮祐、向井 俊太郎、永井 一正、松波 幸寿、小嶋 啓之、南 裕人、糸井 隆夫
東京医科大学 臨床医学系消化器内科学分野
`,
    detail: `　症例は 60 代男性。体重減少を主訴に撮影した CT にて主膵管拡張を指摘され、精査加療目的に紹介受診
となる。血液検査は腫瘍マーカーを含めて特記すべき所見は認めない。造影 CT では膵体尾部に主膵管拡張
を認めるも、明らかな腫瘤は指摘できなかった。MRI においても膵体部で主膵管の狭窄と尾側膵管拡張を認
めたが、狭窄部に腫瘤は指摘できず、拡散強調像においても拡散の低下は認めなかった。EUS では主膵管狭
窄部には明らかな腫瘤を指摘できないが、狭窄のすぐ尾側に 4mm 大の貯留嚢胞と淡い低エコー領域、さら
に尾側の膵管拡張を認めた。上記所見より上皮内癌を疑い、ERP を施行した。膵管造影では膵体部主膵管狭窄 (3mm) と尾側膵管の拡張を認め、狭窄部の分枝膵管は描出されなかった。狭窄部を突破する形で膵管に5Fr ENPD チューブを留置した。膵液細胞診から Adenocarcinoma, suspected が検出され、膵体部癌
(cTisN0M0, cStage0) の術前診断となり、腹腔鏡下膵体尾部切除術を施行した。切除検体の病理所見では高
異型度 PanIN / 上皮内癌に加え、最大 0.5mm 大の微小な浸潤巣を有しており、浸潤性膵管癌 (pT1aN0M0,
pStage Ⅰ A) の診断に至った。術前の EUS では膵管狭窄部に明らかな腫瘤を指摘できなかったが、淡い低エ
コー部は随伴性膵炎をとらえていたと考えた。術前に浸潤性膵管癌と疑う所見が存在したかをご討議いただ
きたい。`,
    link: "/case/pl-3",
    dicomlink: ["https://app.lookrec.com/viewer/v2/consulting/viewer?t=NTc0YmI1YmVlYmNmZGVmNTY1Njg1N2VkYTYzMTFhYTlmNWE5MzNkY2Y0NWI0YjQxNGEyZjcwNTAxNWI2NzE0NA==&published=1"]
  },
  {
    caseid: "o-7",
    sessionid:"010",
    title: "16：15〜17：25　口演③　［ その他 ］(演題O-7〜O-9）",
    casetitle: "O-07   FHCSとの鑑別を要した肝周囲炎の1例 ― IgG4関連疾患か？感染症か？",
    reader:"船登　智將（亀田総合病院）",
    members: `○船登 智將、大野 航、川添 夕佳、蘆川 尭、西脇 拓郎、川満 菜津貴、吉村 茂修、白鳥 俊康、中路 聡
亀田総合病院`,
    detail: `　61 歳女性 . 3 週間持続する右上腹部痛を主訴に近医を受診．腹部 US で胆嚢壁肥厚，CT で肝周囲の炎症
および胆嚢頸部に造影効果を伴う不整隆起を認め当院紹介となった．肝ダイナミック CT の動脈相で肝被膜
下に濃染像と，単純 MRI では肝表に拡散制限低下を伴う T2WI 高信号を認め , 肝周囲炎と考えられた．
Fitz-Hugh-Curtis 症候群（FHCS）の可能性が考慮されたが，病歴上は強く疑えず，クラミジア IgG・IgA 抗体，腟分泌物中の培養も陰性であった . 抗菌薬治療を行うも症状と炎症反応の改善に乏しかった．胆嚢病変に対する EUS では，悪性所見に乏しく ADM と診断した．確定診断困難のため，胆嚢摘出術を兼ねて施行した審査腹腔鏡では，肝表と腹壁間に線維性癒着（violin-string adhesions）を認めたが , 検体中の淋菌・クラミジアは陰性であった．病理所見では，胆嚢・肝グリソン鞘・腹膜に IgG4 陽性細胞浸潤を認め , IgG4 関連疾患が疑われた．血清 IgG4 は 125.7 mg/dL と著明な上昇は認めなかったが，診断的治療を兼ね PSL30 mg/ 日を投与する方針とした．投与後症状は消失し炎症反応も改善したが , PSL 減量による再燃と , 増量による軽快を繰り返した . 画像検査上は，FHCS との整合性がみられるが，起因菌の証明に至らず，好発年齢・治療反応性から IgG4 関連肝周囲炎と診断された．本症例では FHCS との鑑別が問題となったが，IgG4 関連疾患と考えてよいのか？他に考えうる疾患があるのか？について意見を求めたい .`,
    link: "/case/o-7",
    dicomlink: ["https://app.lookrec.com/viewer/v2/consulting/viewer?t=YTBkNjBjMGU1MTg4ZjkwNDI4ZjQyY2M3NjJjYzIyZWVmNTY0MWIxYzkxMTYyZjY5ZmY1YjQ4NjFlNmFlZGYxZA==&published=1"]
  },
  {
    caseid: "o-8",
    sessionid:"011",
    title: "16：15〜17：25　口演③　［ その他 ］(演題O-7〜O-9）",
    casetitle: "O-08   平滑筋腫との鑑別が困難であった成人胃重複症の一例",
    reader:"古原　由理亜（富山大学　学術研究部医学系　消化器・腫瘍・総合外科）",
    members: `○古原 由理亜<sup>1）</sup>、櫻井 太郎<sup>1）</sup>、三輪 武史<sup>1）</sup>、渡辺 徹<sup>1）</sup>、渋谷 和人<sup>1）</sup>、橋本 伊佐也<sup>1）</sup>、奥野 のり子<sup>2）</sup>、平林 健一<sup>2）</sup>、藤井 努<sup>1）</sup>
1）富山大学 学術研究部医学系消化器・腫瘍・総合外科、2）富山大学 学術研究部医学系病理診断科
`,
    detail: `　症例は 63 歳女性。前医で 12 年前から胃噴門部の粘膜下腫瘤様病変を指摘され、ＣＴ検査で経過観察さ
れていた。緩徐に増大傾向を認めたため、超音波内視鏡検査を施行されたところ、胃噴門部に固有筋層から
連続する内部低エコーの壁外突出型腫瘤を認め、平滑筋腫が疑われた。精査加療目的に当院紹介となった。造影ＣＴ検査では噴門直下の後壁に壁外へ突出する 40 mm 大の腫瘤性病変を認めた。血液検査では腫瘍マーカーを含め異常所見を認めなかった。画像所見からは胃平滑筋腫等の粘膜下腫瘍を疑ったものの、有茎性のため生検は困難であり確定診断には至らなかった。増大傾向を示しており悪性の可能性を否定しきれなかったため、外科的切除の方針とした。術式はロボット支援下噴門側胃切除術、食道残胃吻合（mSOFY法）を施行した。手術時間は 3 時間 52 分、出血は少量で術後合併症を認めず、術後 7 日で退院となった。標本の肉眼所見では 40 mm 大の嚢胞性病変であり胃内腔との交通は認めなかった。病理組織学的には、嚢胞内腔は単層の異型に乏しい立方上皮、線毛上皮、一部は腸上皮で裏打ちされており、腫瘤性の異型を伴わず、本来の胃壁と固有筋層を共有していることから胃重複症と診断した。成人発見の胃重複症は稀であり、文献的考察を加え報告する。`,
    link: "/case/o-8",
    dicomlink: ["https://app.lookrec.com/viewer/v2/consulting/viewer?t=YjYxYTJmODExNDNmODA2NTU0YzcyYTZiMTRjMmZlZGExMzIwNzgyZDI4MmEyOGEyNzAwZDAwOTkxZmYyMTdjNA==&published=1"]
  },
  {
    caseid: "o-9",
    sessionid:"012",
    title: "16：15〜17：25　口演③　［ その他 ］(演題O-7〜O-9）",
    casetitle: "O-09   十二指腸異所性膵から発生した膵管癌の一切除例",
    reader:"髙栁　卓矢（大森赤十字病院）",
    members: `○髙栁 卓矢、須藤 拓馬、日吉 雅也、河内 洋、坂本 穆彦、井田 智則
大森赤十字病院
`,
    detail: `　症例は 63 歳男性．貧血精査目的の CT で十二指腸下行脚に腫瘤性病変を認め当科へ紹介となった．造影
CT で腫瘤は約 38mm 大，比較的境界明瞭で，動脈相で低吸収，平衡相で均一な造影効果を呈した．MRIで
は T1WI 低信号，T2WI 高信号，DWI では拡散制限を認め，MRCP では主膵管に異常所見は認めなかった．
EGD では腫瘤頂部の自壊と湧出性出血を伴う 30mm 大の粘膜下腫瘤として認め，EUS で境界明瞭な mixed
echoic な腫瘤として描出され，膵頭部は同腫瘤により圧排されていた．腫瘍マーカーは CEA 0.8 ng/ml,
CA19-9 14.6 U/ml．急速な Hb の低下と活動性出血を認めたため，生検・EUS-FNA は行わず，画像所見よ
り GIST と診断し十二指腸部分切除を施行した．病理組織学的には，腫瘤は線維化を伴う異所性膵組織に囲
まれており，内部に乳頭管状構造を示す腺癌を認めた．腫瘍は嚢胞状構造内に存在するように見える領域と
間質への浸潤を示す領域が混在し，後者には退形成癌の成分を伴っていた．異所性膵の膵管内に発生し，嚢
胞状発育を経て間質浸潤を呈した浸潤性膵管癌と診断した．
十二指腸異所性膵管癌を疑うべき画像所見のポイントを討議したい．`,
    link: "/case/o-9",
    dicomlink: ["https://app.lookrec.com/viewer/v2/consulting/viewer?t=MjEzZTNlYjc4ZTMyZWQ1OGNjZThmMzI3MzYxYmM0OGQzZTRjYzdjOTU4NDQ0ZmY2ZDk3NzkyMDFlYWFlZGQ1NQ==&published=1"]
  },
  {
    caseid: "o-10",
    sessionid:"013",
    title: "08：35〜09：45　口演④　［ 膵臓1 ］(演題O-10〜O-12）",
    casetitle: "O-10   強い造影効果を伴う腫瘤を随伴し、PanNENとの鑑別に難渋したHigh-grade PanINの一例",
    reader:"佐々木　雅隆（名古屋大学 大学院 医学系研究科 消化器内科学）",
    members: `○佐々木 雅隆<sup>1）</sup>、山雄 健太郎<sup>1）</sup>、石川 卓哉<sup>1）</sup>、水谷 泰之<sup>1）</sup>、飯田 忠<sup>2）</sup>、植月 康太<sup>1）</sup>、高田 善久<sup>1）</sup>、青井 広典<sup>1）</sup>、熊野 良平<sup>1）</sup>、川嶋 啓揮<sup>1）</sup>
1）名古屋大学大学院 医学系研究科消化器内科学、2）名古屋大学医学部附属病院 光学医療診療部
`,
    detail: `　症例は 75 歳、男性。左側腹部痛を主訴に受診し、膵尾部を主座とした急性膵炎と診断された。膵炎寛解
後の各種画像検査で膵尾部腫瘤を指摘され当院に紹介となった。腹部造影 CT では膵体尾部に門脈相、平衡
相にて漸増性に強く造影される 10㎜径の腫瘤を認めた。この腫瘤は尾側に主膵管狭窄および限局性膵実
質萎縮を伴っていた。MRCP では膵尾部に尾側膵管拡張を伴う主膵管狭窄を認めた。EUS では指摘の腫瘤
性病変は 10mm 径で境界明瞭、輪郭整であり、造影 EUS では早期相から多血性に染影される所見から、神
経内分泌腫瘍（PanNEN）を強く疑った。EUS-TA で確定診断が得られなかったものの、各種所見から
PanNEN を第一の鑑別に挙げ、膵体尾部切除術を施行した。切除病理標本では主膵管狭窄部の上皮に増殖す
る高度異型円柱上皮細胞を認め、浸潤所見はなく High-grade PanIN と診断した。画像で指摘された多血腫瘤域は PanIN 周囲の腺房脱落および線維化領域と一致していた。既報では同部が淡い多血性を示すと報告はあるが、ここまで強い造影効果の報告はなく、この異常所見について画像および病理学的に検討いただきたい。`,
    link: "/case/o-10",
    dicomlink: ["https://app.lookrec.com/viewer/v2/consulting/viewer?t=MzJhMTVhNTY1ZGYyODNiODEzNzA0YzAzYzQyZGI2YTQwN2FkNjFlOWJhYmFkOTk2Yjg2ZWQ0MTQ3OTY5NjZhYg==&published=1"]
  },
  {
    caseid: "o-11",
    sessionid:"014",
    title: "08：35〜09：45　口演④　［ 膵臓1 ］(演題O-10〜O-12）",
    casetitle: "O-11   浸潤癌が疑われた病変に対し、残膵全摘を施行した上皮内癌の１例",
    reader:"大澤　高陽（愛知医科大学 消化器外科）",
    members: `○大澤 高陽、安藤 公隆、深見 保之、金子 健一朗、松村 卓樹、篠原 健太郎、上田 翔、安井 講平、大岩 立学、佐野 力
愛知医科大学 消化器外科
`,
    detail: `　症例は 83 歳男性。潰瘍穿孔で幽門側胃切除、B-I 再建の既往あり。体重減少と心窩部痛を主訴に近医受
診し膵頭部腫瘤を指摘され紹介受診。造影 CT では約 20mm 大の乏血性腫瘍を認めた ( 図 1)。EUS でも一
部嚢胞成分を伴う結節性病変として描出され FNA で腺癌が検出された。CEA 2.8ng/ml, CA19-9 4498 U/
ml. 膵頭部癌の診断で膵頭十二指腸切除を施行し経過良好で第 13 病日に軽快退院となった。病理組織学的
所見は高分化型腺癌で TS1(19mm), int, ly1, v1, ne0, mpd1(15mm), T1c, CH0, DU0, S0, RP0, PV0, A0, OO0,
N0 Stage IA であった。術中迅速で膵断端に悪性像を認めなかったが、永久標本で上皮内癌の成分を認めた。
慎重な経過観察を行っていたところ、2 年後の造影 CT で残膵の主膵管拡張と膵腸吻合部近傍に約 10mm 大
の造影効果を伴う結節を認めた ( 図 2)。PET でも吻合部近傍と残膵に集積を認めた ( 図 3)。CEA
3.4ng/ml, CA19-9 417 U/ml. EUS-FNA で腺癌の診断となり、残膵全摘を施行し第 14 病日に退院した。残
膵の病理組織学的所見は拡張した膵管内に上皮内癌の広範な進展を認めたが、明らかな間質浸潤は認めな
かった。検討していただきたい項目は、①フォローアップの画像で、進行癌を否定できる余地はあるか。
②残膵の病理組織像に関して、浸潤癌の成分はないと言えるか。`,
    link: "/case/o-11",
    dicomlink: ["https://app.lookrec.com/viewer/v2/consulting/viewer?t=MDc2OTc2MWRhZTFjZmU4NGJkOGI0MDJhN2NmZTg1MTdmNmNiZDM1YzI2OTRiNTY2ZDI5NTllMTk0MzBkMzA1Nw==&published=1"]
  },
  {
    caseid: "o-12",
    sessionid:"015",
    title: "08：35〜09：45　口演④　［ 膵臓1 ］(演題O-10〜O-12）",
    casetitle: "O-12   膵上皮内癌と連続性を有した膵退形成癌の1例",
    reader:"吉川　成一（長岡赤十字病院　消化器内科）",
    members: `○吉川 成一<sup>1）</sup>、夏井 一輝<sup>1）</sup>、盛田 景介<sup>1）</sup>、竹内 学<sup>1）</sup>、皆川 昌広<sup>2）</sup>、谷 達夫<sup>2）</sup>、谷 由子<sup>3）</sup>、田⼝ 貴博<sup>4）</sup>、薄田 浩幸<sup>4）</sup>
1）長岡赤十字病院 消化器内科、2）長岡赤十字病院 外科、
3）長岡赤十字病院 放射線科、4）長岡赤十字病院 病理診断部
`,
    detail: `　【症例】70 歳代、女性。肝機能異常を指摘され X 年 9 月に当院へ紹介となった。CT・MRI にて十二指腸乳頭部から膵頭部の主膵管内腔に 23mm 大の多血性腫瘍が見られ、尾側膵管と総胆管の拡張を伴っていた。上部消化管内視鏡では Vater 乳頭部に白苔を伴った腫瘍が露出し、EUS ではやや低エコーの腫瘍が乳頭部膵管から主膵管内腔に充満するように見られた。造影 EUS では早期から後期にかけて高度に造影され、鑑別疾患として神経内分泌腫瘍や Vater 乳頭部癌、ITPN、膵腺房細胞癌等が考えられたが、腫瘍露出部からの生検では低分化型腺癌との診断であった。Ｘ年 11 月に手術（SSPPD）を施行したところ、病理診断は一部に多型細胞型と破骨型多核巨細胞を伴う紡錘細胞型の膵退形成癌であり (pT3N1aM0)、切除検体の主膵管と分枝膵管の広範囲に high grade (HG) PanIN がみられた。尾側膵管内に突出した腫瘍部の表層は HG- PanIN で覆われており、特に腫瘍先端部は異型が強く浸潤性膵管癌様であった。さらに深部の膵退形成癌との連続性も見られ、膵上皮内癌から通常型膵癌を経て膵退形成癌へ分化・脱分化した移行部の可能性も考えられた。
【検討項目】①画像所見で膵退形成癌を疑う所見の有無について、②膵上皮内癌から膵退形成癌へ連続している部位が移行部である可能性について、ご検討をお願い致します。`,
    link: "/case/o-12",
    dicomlink: ["https://app.lookrec.com/viewer/v2/consulting/viewer?t=ZDM2MjNmMTMzZWE3MTQxMDJhZjU4YTZhMzJkNDRlN2E2YTNlMWE2MzkxNmM1OGYyMGIyNTM2YTdiNDc3YjM4OA==&published=1"]
  },
  {
    caseid: "pl-4",
    sessionid:"016",
    title: "13：15〜14：45　プレナリーセッション2　［ 教育的・典型的症例 ］(演題PL-4〜PL-6）",
    casetitle: "PL-4   肝門部領域胆管癌(Bismuth type IIIb) として手術加療を行なった胆管内発育型肝細胞癌の一例",
    reader:"山中　良輔（東京女子医大病院 消化器・一般外科）",
    members: `○山中 良輔<sup>1）</sup>、大目 祐介<sup>1）</sup>、川本 裕介<sup>1）</sup>、有泉 俊一<sup>1）</sup>、本田 五郎<sup>1）</sup>、古川 徹<sup>3）</sup>、中井 陽介<sup>2）</sup>
1）東京女子医大病院 消化器・一般外科、2）東京女子医大病院 消化器内科、
3）東北大学大学院医学系研究科 病態病理学部門
`,
    detail: `　症例は 50 歳台男性。人間ドックの MRI で左肝内胆管拡張を認めたため紹介となった。MRI では総肝管
から左肝管内を占拠する腫瘍性病変を認め、その末梢の B2,3,4 の拡張を認めた。一方で、採血では肝酵素
の軽度上昇を認めるのみで、黄疸は認めなかった。造影 CT でも同様に左肝管から総肝管に腫瘍性病変を認
めたが、主要脈管への浸潤は明らかではなかった。ERC では肝門部胆管に不整な陰影欠損を認め、左肝管
は造影されなかった。右肝管、総胆管壁の不整は認めなかった。胆道鏡で観察すると肝門部から左肝管に
かけて乳頭状腫瘍を認めた。生検で悪性所見は認めなかったが、画像所見から乳頭状発育型の肝門部領域
胆管癌 (Bismuth typeIIIb) として、左肝尾状葉切除および肝外胆管切除を施行した。切除標本では、肉眼的
に肝門部領域胆管内に増生する腫瘍を認め、組織学的には肝細胞様の腫瘍細胞索が肝実質から胆管内に増
殖している所見であった。免疫染色にて Hepatocyte 陽性、Glypician 陽性であり、胆管内発育型肝細胞の診断となった。術後 4 ヶ月で多発肝内再発を来たし、現在化学療法中である。
乳頭状発育型の肝門部領域胆管癌として手術加療を行い、術後診断が胆管内発育型肝細胞癌であった一切
除例を経験した。術前画像から肝細胞癌と診断可能であったかについて議論いただきたい。`,
    link: "/case/pl-4",
    dicomlink: ["https://app.lookrec.com/viewer/v2/consulting/viewer?t=YTAzNTgyNTIyYTU2ZDA5MWIyNjU2YTZlMmY4MWEzZDJlZWE0N2RkNDE4Y2E4OWYzOTFkZWFlZDJlNzdlNDAyNA==&published=1"]
  },
  {
    caseid: "pl-5",
    sessionid:"017",
    title: "13：15〜14：45　プレナリーセッション2　［ 教育的・典型的症例 ］(演題PL-4〜PL-6）",
    casetitle: "PL-5   胆嚢癌との鑑別を要した黄色肉芽腫性胆嚢炎の1例",
    reader:"谷坂　優樹（埼玉医科大学国際医療センター 消化器内科）",
    members: `○谷坂 優樹<sup>1）</sup>、良沢 昭銘<sup>1）</sup>、水出 雅文<sup>1）</sup>、藤田 曜<sup>1）</sup>、渡邊 隆一<sup>1）</sup>、合川 公康<sup>2）</sup>、岡本 光順<sup>2）</sup>、岡田 吉隆<sup>3）</sup>、美山 優<sup>4）</sup>、本間 琢<sup>4）</sup>
1）埼玉医科大学国際医療センター 消化器内科、2）埼玉医科大学国際医療センター 消化器外科、
3）埼玉医科大学国際医療センター 画像診断科、4）埼玉医科大学国際医療センター 病理診断科
`,
    detail: `　症例は 70 代 , 女性 . IgG4 関連硬化性胆管炎でステロイド加療を行っていた . 治療開始 10 か月後の経過
観察目的で CT 検査を行ったところ , 胆嚢体部から底部にかけて腫瘤状の壁肥厚が見られ , 壁外にかけては
腫瘤形成を認めた . 腫瘤は肝湾曲部に及んでいた . 腫瘤内部には低濃度域の混在あり , 遷延性の造影効果が
認められた . 胆嚢頸部には結石がみられた . MRI 検査では壁肥厚部は T2 強調像で高信号であり , 造影 MRIでは壁が強く造影されるが , 壁内には低吸収域も認められた . 以上より , 胆嚢癌もしくは黄色肉芽腫性胆嚢炎を考えたが , 治療方針決定のため組織検査が必要と考え , 超音波内視鏡検査 (EUS) を施行した . 体部から底部にかけての壁肥厚部は高エコーで描出され , 一部低エコー部が混在していた . 造影 EUS では , 壁肥厚部は早期に造影効果を認めた . 同壁肥厚部から EUS-FNA を施行した . 採取された組織は著明な微小空胞を伴う組織球浸潤を認め , 泡沫細胞浸潤主体の炎症を疑った . 悪性所見は認めなかった . 黄色肉芽腫性胆嚢炎の術前診断で腹腔鏡下胆嚢摘出術を施行した . 病理組織学的所見としては , 明調な細胞質を有する細胞や , リンパ球と共に脂質を貪食した泡沫細胞がびまん性に増殖していた. 以上より黄色肉芽腫性胆嚢炎と最終診断した .
①術前画像診断で胆嚢癌と黄色肉芽腫性胆嚢炎の鑑別ができたかどうか , ②今回の EUS-FNA 所見で黄色肉
芽腫性胆嚢炎と診断して良いかどうか討論できたらと考える .`,
    link: "/case/pl-5",
    dicomlink: ["https://app.lookrec.com/viewer/v2/consulting/viewer?t=OWFmMGIyNGJlMjY0YjcyODA3NmZhMGI2Y2IyNjZhYzVkYzNiMzAyZGRiMjEzOGU4YzUwNDFiNzhlMDgxZWIxYg==&published=1"]
  },
  {
    caseid: "pl-6",
    sessionid:"018",
    title: "13：15〜14：45　プレナリーセッション2　［ 教育的・典型的症例 ］(演題PL-4〜PL-6）",
    casetitle: "PL-6   膵神経内分泌腫瘍（P-NEN）に類似した画像所見を示した濾胞性膵炎の1例",
    reader:"谷﨑　卓実（熊本大学　消化器外科）",
    members: `○谷﨑 卓実、林 洋光、耕 佳徹、小川 大輔、白石 裕大、山尾 宣暢、北野 雄希、宮田 辰徳、岡部 弘尚、岩槻 政晃
熊本大学 消化器外科`,
    detail: `　79 歳の女性、健診の腹部超音波検査（AUS）にて指摘された膵頭部嚢胞性病変（IPMN 分枝型の疑い）のフォロー中、膵体尾部に増大傾向を示す 12mm の多血性腫瘤を新たに指摘された。
同腫瘤は造影 CT で動脈相で周囲の膵実質より造影効果を有し、MRI の T1WI、T2WI で共に低信号で、軽
度の拡散制限あり。ADC 値の低下はなかった。また、膵実質の脂肪変性も指摘された。
ソマトスタチン受容体シンチグラフィー（SRS）では、腫瘤に一致した淡い集積を認めた。EUS-FNA で一
部に INSM1、Synaptophysin、ChromograninA 陽性の細胞を認めたが、全体像はクローナルな細胞とは言い難く、腫瘍性病変の診断には至らなかった。
P-NEN 疑いの術前診断として、腹腔鏡下脾温存膵体尾部切除術が施行された。
切除病理組織検査では、多数のリンパ濾胞の形成や膵実質の萎縮、線維化、また、慢性炎症や導管の損
傷を反映するような好酸性変化（oncocytic changes）が目立ち、濾胞性膵炎の診断であった。
【討論したいポイント】濾胞性膵炎は画像診断が困難であるが、今回の pitfall は背景膵の脂肪変性にも起
因すると考える。そのような要因で診断に苦慮した症例はあるか。また、濾胞性膵炎の画像診断における
ポイントがあれば、討論いただきたい。`,
    link: "/case/pl-6",
    dicomlink: ["https://app.lookrec.com/viewer/v2/consulting/viewer?t=OGI1N2Y5ZjJhOGU2NWI0ZThhOGM2MmQ2ZDY3MjExMjA0MTU4YjEwYzQzNWI2MDg4NTcwNDM0Y2VmODhjMzc5YQ==&published=1"]
  },
  {
    caseid: "o-13",
    sessionid:"019",
    title: "14：55〜16：05　口演⑤　［ 膵臓2 ］(演題O-13〜O-15）",
    casetitle: "0-13   自己免疫性膵炎様の組織像を伴った浸潤性IPMCの1切除例",
    reader:"細川　健斗（仙台市医療センター　仙台オープン病院　消化管・肝胆膵内科）",
    members: `○細川 健斗<sup>1）</sup>、岡野 春香<sup>1）</sup>、越田 真介<sup>1）</sup>、菅野 良秀<sup>1）</sup>、小川 貴央<sup>1）</sup>、村上 一宏<sup>2）</sup>、澤井 高志<sup>2）</sup>、野田 裕<sup>3）</sup>、伊藤 啓<sup>1）</sup>
1） 仙台市医療センター仙台オープン病院 消化管・肝胆膵内科、2） 仙台市医療センター仙台オープン病院 病理診断科、
3） 仙台市医療センター仙台オープン病院 健診センター`,
    detail: `　症例は 72 歳男性。健診の PET-CT で膵尾部の異常集積を指摘され当院紹介となった。過去の喫煙歴（20
本× 15 年）があり、飲酒歴はなく、膵癌の家族歴はなかった。血清 CEA、CA19-9、DUPAN-2 および
IgG4 値は基準内であった。造影 CT で膵尾部に嚢胞成分を含む 20 mm 大の乏血性腫瘤と尾側の主膵管拡
張を認めた。MRI で腫瘤は T1 低信号、T2 軽度高信号、拡散の軽度低下、MRCP で同部は 1cm 強の多房
性嚢胞を伴う主膵管狭窄を呈し、尾側主膵管の拡張を認めた。EUS では不整な厚い隔壁構造からなる多房
性の嚢胞構造を含んだ低エコー腫瘤として描出され、ソナゾイド造影で同腫瘤は周囲膵同様の造影効果を
呈した。2 回の EUS-FNA 検体の組織像では、いずれもリンパ球浸潤伴う線維組織と少量の IgG4 陽性細胞
を認めた。画像で悪性を強く疑ったため３回目の EUS-FNA と膵液細胞診を施行し、いずれも腺癌を検出し
た。浸潤性 IPMC や浸潤性膵管癌を疑い、膵体尾部切除術を施行した。切除膵標本の組織像では、膵尾部
に 15 mm 程の浸潤を伴う IPMC を認め、同部およびその尾側膵には多数のリンパ濾胞と高度な線維化を認
めた。この線維組織内には閉塞性静脈炎と多くの IgG4 陽性細胞 (>10 個 /HPF) を認め、自己免疫性膵炎様
の組織像を呈していた。本症例の診断の妥当性、画像診断上の鑑別点について討論頂きたい。`,
    link: "/case/o-13",
    dicomlink: ["https://app.lookrec.com/viewer/v2/consulting/viewer?t=NDgyMDIwMWQzYmI4YTJmMmQxM2NhMzM0NzI1ZTBiOWQxZWE4NmUzZDFiMzJiMzU0MmQ2M2JjNmY5NzAzMjU0ZA==&published=1"]
  },
  {
    caseid: "o-14",
    sessionid:"020",
    title: "14：55〜16：05　口演⑤　［ 膵臓2 ］(演題O-13〜O-15）",
    casetitle: "0-14   IPMN を合併した自己免疫性膵炎の一例",
    reader:"竹腰　大也（信州大学医学部附属病院放射線科）",
    members: `○竹腰 大也<sup>1）</sup>、吉澤 恵理子<sup>1）</sup>、倉石 康弘<sup>2）</sup>、野竹 剛<sup>3）</sup>、佐藤 良紀<sup>4）</sup>、山田 哲<sup>1）</sup>、藤永 康成<sup>1）</sup>
1） 信州大学医学部附属病院 放射線科、2） 信州大学医学部附属病院 消化器内科、
3） 信州大学医学部附属病院 消化器外科、4） 信州大学医学部附属病院 病理診断科
`,
    detail: `　症例は 70 歳代男性 . 膵管内乳頭粘液性腫瘍（IPMN）疑いにて前医にて経過観察されていた . 主膵管は最
大径 7 mm とびまん性に拡張し , 膵実質にも萎縮を認めた . 経過で胆嚢腫瘍を認め , 精査目的に撮影した造
影 CT にて膵尾部の拡張した主膵管辺縁に , 径 10mm 大の遅延性に造影される壁在結節様陰影を認め
た .MRI では同病変は DWI にて高信号を呈し, MRCP では同病変近傍に主膵管の狭細像を認めた . 浸潤癌を伴うIPMN を疑いMR 検査の 10 日後にFDG-PET を施行した所, 膵尾部は著明に腫大し強いFDG 集積（SUV
max 13.6）を認めた . 造影 CT の再検では膵尾部は腫大し胃との境界が不明瞭化 , また拡張した膵管内に空
気が認められ胃との穿通が示唆された . 患者は炎症反応上昇を認めたものの自覚症状は乏しかった為 , 悪性
度の高い腫瘍の急速な増大の可能性も考えたが , まずは急性膵炎に準じた保存的加療を行い ,1 週間後に撮
像されたCT にて膵尾部の腫脹軽快を認めた為, 腫大は膵癌による主膵管狭窄に伴う閉塞性膵炎を疑った. 膵体尾部切除を施行 , 病理学的に high grade IPMN および自己免疫性膵炎と診断し , 膵管狭窄の主な原因は自
己免疫性膵炎と考えた . 診断後に血清 IgG4 値を測定したが上昇は認めなかった . 本症例は術前診断にて膵
炎の可能性を言及すべきであった症例であり , 後方視的に自己免疫性膵炎の可能性を言及出来る所見は無か
ったか , また病理学的に病変と IPMN との関連の有無 , なぜ IPMC 様に見えてしまったのかについて討議したい .`,
    link: "/case/o-14",
    dicomlink: ["https://app.lookrec.com/viewer/v2/consulting/viewer?t=NzUyYjRiNzQ1NGZiZTA0OTYwZjY5ZTZmMjQ1Nzk5NmM5Y2Y2ZDg5MGZiODgwM2YzY2MzZDQxZTYxMmM2YTYxOQ==&published=1"]
  },
  {
    caseid: "o-15",
    sessionid:"021",
    title: "14：55〜16：05　口演⑤　［ 膵臓2 ］(演題O-13〜O-15）",
    casetitle: "0-15   限局性主膵管狭窄をきたした腫瘤形成のない自己免疫性膵炎の一例",
    reader:"金丸　薫子（神戸大学医学部附属病院 消化器内科）",
    members: `○金丸 薫子<sup>1）</sup>、酒井 新<sup>1）</sup>、小林 隆<sup>1）</sup>、増田 充弘<sup>1）</sup>、宇座 徳光<sup>1）</sup>、児玉 貴之<sup>2）</sup>、児玉 裕三<sup>1）</sup>
1）神戸大学医学部附属病院 消化器内科、2）神戸大学医学部附属病院 病理診断科
`,
    detail: `　【症例】73 歳 , 男性 . 健診の血液検査にて膵酵素上昇を認め近医を受診した . 腹部 CT 検査にて膵体部主膵管の軽度拡張を指摘され , 当院紹介となった . 血液検査ではアミラーゼ 55U/L, リパーゼ 100U/L と膵酵素
上昇を認め , 血清 IgG4 は 295mg/dL と高値であった . 腫瘍マーカーは CA19-9, CEA, DUPAN-2, Span-1のいずれも基準値以下であった . EUS では膵実質の腫大や腫瘍性病変は指摘できず , 膵体部主膵管は径 3mm
程度に拡張し , 拡張した主膵管の壁肥厚を認めた . MRCP では膵体部主膵管に 10mm の狭窄を認め ,尾側主
膵管の軽度拡張と分枝膵管の拡張を認めた . ERP では膵体部主膵管に 10mm の狭窄と尾側主膵管のわずか
な拡張を認めた . 狭窄部より擦過細胞診 , 膵液吸引細胞診を行ったところ , 異型細胞を認めた . これらの所
見より早期膵癌を疑い , 膵中央切除術を施行した . 手術検体の病理検査にて主膵管の線維性肥厚 , リンパ球
の浸潤 , IgG4 陽性形質細胞 50 個 /HPF, 花伪状線維化を認めた . 検体中に悪性所見はなく , 自己免疫性膵炎
臨床診断基準（2018）での病理組織学的確診に該当し , 自己免疫性膵炎と診断した . 術後 14 日目に退院し ,
以降ステロイドフリーで膵腫大などの所見なく経過している .
【検討項目】腫瘤形成がなく , 限局性主膵管狭窄をきたした , 稀な画像を呈する自己免疫性膵炎の一例を経験しましたので , 術前の画像診断や主膵管周囲に限局した自己免疫性膵炎の病理に関しまして , ご討議よろしくお願いします .`,
    link: "/case/o-15",
    dicomlink: ["https://app.lookrec.com/viewer/v2/consulting/viewer?t=NjEyOGYxOGVjZDM5MTliZDUxNjNlOGUzN2E2MTZlY2UxYWIxMmMxZjYwYzFlYTQ3MjAzNDM0MjQ4Nzk4ODFiMg==&published=1", "https://app.lookrec.com/viewer/v2/consulting/viewer?t=ZDRiZmFiZWY0MDg3NDIwZjFlOGYyMDM0OTg1N2E3MjViMDEyZmVkODkwNDAwNTllNmQ4YjRiNGM4MmM5NjM2Zg==&published=1"]
  },
  {
    caseid: "o-16",
    sessionid:"022",
    title: "16：15〜17：25　口演⑥　［ 膵臓3 ］(演題O-16〜O-18）",
    casetitle: "0-16   良悪性の鑑別に苦慮した膵頭部膵管狭窄の一例",
    reader:"金谷　和哉（聖隷浜松病院　消化器内科）",
    members: `○金谷 和哉<sup>1）</sup>、小林 陽介<sup>1）</sup>、木次 健介<sup>1）</sup>、海野 修平<sup>1）</sup>、木全 政晴<sup>1）</sup>、芳澤 社<sup>1）</sup>、室久 剛<sup>1）</sup>、細田 佳佐<sup>1）</sup>、山本 博崇<sup>2）</sup>、大月 寛郎<sup>3）</sup>
1）聖隷浜松病院 消化器内科、2）聖隷浜松病院 肝胆膵外科、
3）聖隷浜松病院 病理診断科
`,
    detail: `　症例は、50 歳台女性。既往歴、飲酒歴なし。毎年人間ドックを施行され、膵に異常は認めず。腹部 US で、膵管拡張を認め紹介。症状なく、血液検査では異常なし。US、CT では、主膵管が膵頭部から最大 6mm 大の拡張を認めたが、腫瘤は認めず、膵萎縮等も認めなかった。MRI でも膵管拡張を呈し、DWI では、膵頭部で淡い高信号を呈した。EUS では、膵頭部主膵管が狭窄し、1cm 大の境界不明瞭な低エコーを呈し、 EUS-TA を施行したが、悪性所見は認めず。ERP では、主膵管は膵頭部で狭窄し、尾側膵管は拡張していた。しかし、狭窄が強く病理検査は困難であった。1 ヶ月後に画像検査を再検したが著変なく、PET-CT でも異常は認めなかった。EUS-TA 再検では、反応性異型が疑われたが良悪性の鑑別は困難であった。ERP では、膵管狭窄はやや進行し、尾側膵管は造影されず、初回検査時同様病理検査は困難であった。膵管狭窄の進行を認め、1 年前まで異常がなかったことから、上皮内癌等の可能性も考慮した。手術を希望され、膵頭十二指腸切除術を施行した。病理診断では、腺房萎縮、炎症細胞浸潤、線維化を伴い慢性膵炎による膵管狭窄であり、悪性所見は認めなかった。慢性膵炎を疑う経過は認めず、膵管狭窄が出現した点から悪性狭窄を疑ったが、炎症による良性狭窄であった。術前病理検査が困難であり診断により難渋した。画像評価や診断に苦慮する膵管狭窄に対する対応等を含め議論頂きたい。`,
    link: "/case/o-16",
    dicomlink: ["https://app.lookrec.com/viewer/v2/consulting/viewer?t=Zjg4ZjgxMjUxYzlhN2NiMDdmZGI4YjUzNzBmMWM4MjQ3MzQ5N2Y2OTYzNTRkYjk1YWIyYWEyOWU0YzFiNDY4ZA==&published=1"]
  },
  {
    caseid: "o-17",
    sessionid:"023",
    title: "16：15〜17：25　口演⑥　［ 膵臓3 ］(演題O-16〜O-18）",
    casetitle: "0-17   重複する膵野型浸潤癌の1例",
    reader:"池田　恵理子（自治医科大学内科学講座消化器内科部門）",
    members: `○池田 恵理子<sup>1,2）</sup>、菅野 敦<sup>1）</sup>、佐野 直樹<sup>2）</sup>、安藤 梢<sup>1,2）</sup>、横山 健介<sup>1）</sup>、笹沼 英紀<sup>3）</sup>、福嶋 敬宜<sup>2）</sup>、矢野 智則<sup>1）</sup>
1）自治医科大学内科学講座 消化器内科部門、2）自治医科大学病理診断部 病理診断科、
3）自治医科大学外科学講座 消化器一般移植外科部門
`,
    detail: `　膵体部の単房性嚢胞を 13 年間経過観察中であった 78 歳男性。MRCP で膵尾部に T1WI 低信号、T2WI軽
度高信号、拡散が低下した領域が認められ、同部位で主膵管が狭窄していた。EUS では膵尾部に①主膵管狭窄②さらに尾側の膵野に 7mm 大の境界明瞭な低エコー腫瘤の 2 病変が認められた。①主膵管狭窄周囲には膵実質の萎縮が軽度認められ、膵上皮内癌を疑った。②に対する EUS-FNA では Adenocarcinoma が得られた。
以上より①膵上皮内癌と②膵野型浸潤癌と診断し、術前化学療法の後、膵体尾部切除術を施行した。標本造
影検査では膵尾部に①主膵管狭窄、検体超音波検査では①から 16mm 尾側に② 7mm 大の低エコー腫瘤が認
められ、各々マーキングをした。また①主膵管狭窄部の背側に境界不明瞭な淡い低エコー領域も認められた。
病理組織学的には主膵管狭窄部を含め、主膵管上皮には異型が認められなかったが、
①主膵管狭窄部背側の淡い低エコー領域近傍に小葉管結合組織や血管に沿って軸索状に広がる浸潤癌が認
められ、主膵管は浸潤癌の一部に巻き込まれ狭窄していた。② 7mm 大の腫瘤部にも浸潤癌が認められた。
①と②では組織学的な形態が異なっており別病変と推測した。背景膵の膵萎縮は明らかではなかった。後
方視的には EUS で①主膵管狭窄周囲膵実質の萎縮と判断していた領域に浸潤癌が進展していた。重複する
膵野型浸潤癌の 1 例を経験した。各々の浸潤癌の発生や進展様式、その画像診断に関して興味深い症例と
考えられ報告する。`,
    link: "/case/o-17",
    dicomlink: ["https://app.lookrec.com/viewer/v2/consulting/viewer?t=OWE3YzgyYjQ5NmExNzkzMjRmOTM0MmI0ZmMxNjcwM2U4MWQ0MWU2NjZhNzI0Zjc5OWRhMDA2OGY1ZmZlNzg3YQ==&published=1"]
  },
  {
    caseid: "o-18",
    sessionid:"024",
    title: "16：15〜17：25　口演⑥　［ 膵臓3 ］(演題O-16〜O-18）",
    casetitle: "0-18   膵体部上皮内腫瘍性病変と多発IPMNに対して膵全摘術を施行した一例",
    reader:"島松　裕（東京女子医科大学　消化器内科）",
    members: `○島松 裕<sup>1）</sup>、高山 敬子<sup>1）</sup>、大塚 奈央<sup>1）</sup>、白田 龍之介<sup>1）</sup>、川本 裕介<sup>2）</sup>、本田 五郎<sup>2）</sup>、齊藤 里美<sup>3）</sup>、伊藤 泰斗<sup>3）</sup>、古川 徹<sup>3）</sup>、中井 陽介<sup>1）</sup>
1）東京女子医科大学 消化器内科、2）東京女子医科大学 消化器・一般外科、
3）東北大学大学院 医学系研究科病態病理学分野
`,
    detail: `　70 代男性。20xx-8 年の健診の腹部エコー検査で多発する膵嚢胞を指摘され、当科を受診した。CT で膵
鉤部、膵体尾部に嚢胞性病変を認め、当初は IPMN を疑い、半年毎の経過観察を行っていた。もともと膵頚
部から体部にかけて限局性膵萎縮を認めていたが、経過中に緩徐増悪傾向であったことから、20xx 年に
EUS を施行したところ、膵体部に低エコー域が出現し、同部位に一致して主膵管の狭小化を疑う所見を認めた。造影 CT では明らかな腫瘤は認めなかった。MRI/MRCP では、膵鉤部の嚢胞性病変のほか、膵頚部から体部の萎縮に一致して微小な嚢胞性病変を複数認めた。ERP で膵体部に主膵管の狭小化を認めたことから同部位の擦過細胞診とともに SPACE を行い、細胞診で高度異型を伴う細胞が検出された。浸潤癌を否定するため膵体部の低エコー域の EUS-FNA を行ったが、高度異形成の病理診断であったことから High- grade PanIN を疑い、手術の方針とした。切除病理標本では、膵体部病変は主膵管と周囲の分枝膵管に連続して低乳頭状の不整な上皮増生を認め、極性の乱れと一部複雑な癒合を呈しており、High-grade PanINの所見であった。膵頭部の嚢胞内と膵尾部の拡張した主膵管は粘液を有する細胞で裏打ちされており、 IPMA に矛盾しない所見であった。以上より、最終病理診断は膵体部 High-grade PanIN、多発 IPMA（膵全体）とした。
背景膵には線維化があり発癌との関連や膵全摘の必要性を討論したいポイントとする。
`,
    link: "/case/o-18",
    dicomlink: ["https://app.lookrec.com/viewer/v2/consulting/viewer?t=MzRkNWM2MDdiY2FmNmUyMDZmMjAxZGNkMWViZGFhMjdhN2I1OTk5OTkyODUyZDJlNzNhY2JlMTA2NDliMmEwOA==&published=1"]
  },
  {
    caseid: "p-1",
    sessionid:"025",
    title: "11：00〜11：50　ポスター口演　［ Poster 1 ］（P-1〜P-4）",
    casetitle: "P-1   アルコール性肝硬変患者の高度の脂肪膵に発生したPanIN3並存浸潤性膵管癌の一切除例",
    reader:"髙谷　昌宏（姫路赤十字病院消化器内科）",
    members: `○高谷 昌宏<sup>1）</sup>、高田 斎文<sup>1）</sup>、伏見 聡一郎<sup>2）</sup>、遠藤 芳克<sup>3）</sup>、和仁 洋治<sup>4）</sup>、甲斐 恭平<sup>3）</sup>、岡田 裕之<sup>1）</sup>
1）姫路赤十字病院 消化器内科、2）姫路赤十字病院 病理診断科、
3）姫路赤十字病院 消化器外科、4）姫路赤十字病院 臨床検査科
`,
    detail: `　70 才台男性．膵癌家族歴なし．エタノール換算 80g/ 日の大量飲酒者であったが 21 年前にアルコール
性肝硬変と診断され，以降禁酒した．8 年前（2013 年）には腹部 CT で膵に高度でびまん性の脂肪沈着が
認められた．30 本 / 日の喫煙は続き，糖尿病に罹患していた．2021 年肝癌サーベイランス目的の腹部エ
コー検査で，高輝度の膵実質を背景に膵体部に 20mm の低エコー結節を指摘された．EUS-FNA で腺癌が得られたため膵体尾部切除が施行された．手術時には BMI 25.4，HbA1c 7.8%(NGSP) であった．手術病理では25mm の中分化膵管癌で切除断端に PanIN3 が認められ，pT3, ly2, v1, ne1, mpd0, pS1, pRP0, pN0 [ 規約第 7版-TNM] pT3 N0 M0 (Stage Ⅱ A), R1 切除と診断された．一方，膵実質の殆どは脂肪に置換しており，主病変から離れた腺房組織内の膵管に PanIN3 が複数箇所認められた．患者は追加膵切除を希望せず術後化学療法が行われた．その後肝細胞癌を発症し，膵切除後 18 ヶ月目に残膵再発をきたした．
ご検討いただきたい内容は以下の通りです． ①病理所見から，脂肪膵の原因をアルコール性（慢性膵炎）
かその他の原因かどうかの鑑別が可能かどうか．②脂肪膵が膵管癌及び PanIN3 の原因と考えられる病理
所見があるかどうか．③臨床的に，高度でびまん性の脂肪膵患者に対する膵癌サーベイランスが必要かど
うか，必要であればその方法について．`,
    link: "/case/p-1",
  },
  {
    caseid: "p-2",
    sessionid:"026",
    title: "11：00〜11：50　ポスター口演　［ Poster 1 ］（P-1〜P-4）",
    casetitle: "P-2   範囲診断に難渋した膵体部限局性膵萎縮と広範な膵上皮内腫瘍性病変(High-grade PanIN)を伴うT1a膵癌の1例",
    reader:"島田　康彬（三重大学医学部附属病院）",
    members: `○島田 康彬、山田 玲子、浦田 美菜子、野瀬 賢治、田中 隆光、三輪田 哲郎、中川 勇人
三重大学医学部附属病院
`,
    detail: `　69 歳女性。腹部超音波検査で膵体部限局性萎縮を指摘され当院を受診。CT・MRI で腫瘤や主膵管狭
窄・拡張像は認めないが、EUS(convex) で膵頭部分枝膵管拡張、膵体部萎縮と同部の主膵管壁肥厚を認めた。EUS(radial) で convex 所見に加えて膵体部主膵管周囲に 5mm の低エコー帯を認めた。ERP で主膵管の不整像や拡張・狭窄所見を認めないが、萎縮した膵体部のみ 2 次分枝は造影されず分枝膵管閉塞を生じる膵管内病変の存在が示唆された。5Fr カテーテルで実施した SPACE は class Ⅰ (6/6) の結果であったが画像所見から PanIN/ 上皮内癌の存在を強く疑い、3 ヶ月後に SPACE を再検した。ERP 像は変化を認めず。膵体部の分枝閉塞部から擦過細胞診検体を採取し 5Fr カテーテルで SPACE を行った。SPACE は class Ⅲ a(1/6)、擦過細胞診は class Ⅴを検出し、膵体部上皮内癌と診断した。EUS で低エコー帯を膵頭体移行部に近い膵体部に認め、同部に微小浸潤癌が存在する可能性を否定できないため、膵頭十二指腸切除術を施行した。病理組織学的には萎縮した膵実質は線維化と脂肪組織により置換されているが、ランゲルハンス島は残
存していた。膵頭部から切除断端まで分枝膵管内に High-grade PanIN が広範に存在し、膵体部分枝膵管から発生した 1mm 大の浸潤性膵管癌を認めた。術中迅速検体は陰性で pT1aN0M0 pStage Ⅰ A と診断した。術
前画像所見と切除標本の詳細検討により、術前の正確な範囲診断が可能であったか御討議をお願いし
ます。`,
    link: "/case/p-2",
  },
  {
    caseid: "p-3",
    sessionid:"027",
    title: "11：00〜11：50　ポスター口演　［ Poster 1 ］（P-1〜P-4）",
    casetitle: "P-3   経時的な膵萎縮の進行により診断に至った、膵管内を主な領域とした膵癌の一例",
    reader:"福山　真（福岡大学医学部消化器内科学講座）",
    members: `○福山 真<sup>1）</sup>、石田 祐介<sup>1）</sup>、濱田 義浩<sup>2）</sup>、高山 幸久<sup>3）</sup>、古賀 毅彦<sup>1）</sup>、土屋 直壮<sup>1）</sup>、中島 亮<sup>4）</sup>、梶原 正俊<sup>4）</sup>、吉満 研吾<sup>3）</sup>、平井 郁仁<sup>1）</sup>
1）福岡大学医学部 消化器内科学講座、2）福岡大学医学部 病理学講座、
3）福岡大学医学部 放射線医学教室、4）福岡大学医学部 消化器外科学講座
`,
    detail: `　症例は 60 歳代女性。乳癌術後および脾動脈瘤で経過観察中、術後 13 年目の腹部造影 CT で膵尾部に
15mm 大の限局性膵萎縮を指摘され当科紹介となった。早期相で淡い造影効果を認めるも後期相での造影
効果は不明瞭で、膵管拡張は見られなかった。MRI 脂肪抑制 T1WI では低信号を呈していたが明らかな拡
散制限はなく、EUS では 9mm 程度の不明瞭な低エコー領域として描出された。MRCP および ERP では主
膵管にわずかな不整像を認めるものの、明らかな狭窄や尾側膵管拡張は認めなかった。過去画像との比較
により 4-5 年の経過で萎縮の進行が確認され、連続膵液細胞診 Class IIIb の結果も考慮し、微小膵癌の可能
性を否定できないため膵体尾部切除術を施行した。切除標本では、萎縮部を中心に 20mm 程度の範囲で主
膵管および分枝膵管に上皮内癌を含む異型上皮が確認された。また周囲には顕著な線維化があり、浸潤の
診断が難しい腺管も認められた。膵萎縮の経時的変化を追跡できた貴重な症例として報告する。
`,
    link: "/case/p-3",
  },
  {
    caseid: "p-4",
    sessionid:"028",
    title: "11：00〜11：50　ポスター口演　［ Poster 1 ］（P-1〜P-4）",
    casetitle: "P-4   腹部超音波検査による膵管径の変化が発見契機となった膵上皮内癌(PanIN-3)の１例",
    reader:"長川　達哉（札幌徳洲会病院　消化器内科）",
    members: `○長川 達哉<sup>1）</sup>、岡崎 遼<sup>2）</sup>、浅野 賢道<sup>2）</sup>、平野 聡<sup>2）</sup>、伊野 永隼<sup>3）</sup>、三橋 智子<sup>3）</sup>
1）札幌徳洲会病院 消化器内科、2）北海道大学病院 消化器外科Ⅱ、3）北海道大学病院 病理部
`,
    detail: `　症例は 60 歳台男性、20XX-7 年より定期的に施設健診にて腹部超音波検査を行っていた。膵実質はびま
ん性粗造に描出されるも、20XX-1 年まで体部主膵管は 1.4 ～ 2.4mm 径と正常範囲内であった。20XX 年
の検査では膵体部で主膵管径 4.3mm と拡張所見を認めるも、頭側には明らかな腫瘤像を認めなかった。同時に施行した血液検査では血清膵酵素や腫瘍マーカーの高値および耐糖能異常を認めず、CE-CT, MRI の
axial image でも膵実質に腫瘤像を指摘できなかったが、MRCP では膵頭部主膵管に 12mm 長程度の狭窄部
と末梢側主膵管のびまん性拡張を認め、EUS では膵管狭窄部に 5mm 前後の周囲膵実質よりわずかに低エコ
ーな領域を認めた。ERCP 時の擦過細胞診および ENPD 留置下膵液細胞診にて腺癌細胞が検出され、術前
診断として限局性膵炎を伴う上皮内癌を第一に考え、亜全胃温存膵頭十二指腸切除術を施行した。病理組織
所見では膵頭部の主膵管狭窄部（14mm 長）から分枝膵管内に高度の細胞異型を伴う低乳頭状上皮が拡が
っており、膵管周囲には線維化を伴う炎症所見を認めた。実質浸潤像やリンパ節転移を認めず、膵上皮内癌
（PanIN-3）と診断された。定期的な腹部超音波 screening が膵癌の早期発見の契機となった上皮内癌症例
と考えられ、経時的な超音波画像の変化および膵管像と病理学的所見の対比を中心に報告する。膵上皮内癌
の経過観察例を経験された施設から、膵管径の変化とその病理学的要因につき討論をお願いしたい。
`,
    link: "/case/p-4",
  },
  {
    caseid: "p-5",
    sessionid:"029",
    title: "11：00〜11：50　ポスター口演　［ Poster 2 ］（P-5〜P-8）",
    casetitle: "P-5   画像上は原発巣が同定困難であった微小膵癌の一例",
    reader:"市丸　壽光（九州がんセンター　消化器・肝胆膵内科）",
    members: `○市丸 壽光<sup>1）</sup>、李 倫學<sup>1）</sup>、杉本 理恵<sup>1）</sup>、冨野 高広<sup>2）</sup>、栗原 健<sup>2）</sup>、杉町 圭史<sup>2）</sup>、前原 純樹<sup>3）</sup>、篠﨑 賢治<sup>3）</sup>、古賀 裕<sup>4）</sup>、田口 健一<sup>4）</sup>
1）九州がんセンター 消化器・肝胆膵内科、2）九州がんセンター 肝胆膵外科、
3）九州がんセンター 画像診断科、4）九州がんセンター 病理診断科
`,
    detail: `　症例は 76 歳男性。検診の二次精査（CEA 5.3 ng/mL）目的にて前医で各種画像検査を施行された。
MRCP では、膵頭部の主膵管に限局性の途絶を認めたが、造影 CT・MRI では途絶部を含めて膵内に明らかな腫瘤性病変は指摘できず、FDG-PET でも有意な異常集積はなかった。精査目的に当科紹介され、EUS では門脈前面付近で主膵管の限局性途絶は認めるものの穿刺対象となる占拠性病変は同定できず。ERP では、尾側膵管の軽度拡張を伴う膵頭部での主膵管の高度狭窄あり、同部では十分に圧をかけても分枝膵管の描出
は不良であった。狭窄部からの擦過細胞診と SPACE で Class V；腺癌が検出され、狭窄部近傍が原発の膵臓癌と診断した。
右腎癌との重複癌症例であったが膵臓癌の治療を優先させる方針となり、ロボット支援下亜全胃温存膵
頭十二指腸切除術を施行した。切除標本では主膵管狭窄部は確認できたが腫瘤は認めず、浸潤癌胞巣が散
在し主膵管周囲に限局性膵萎縮も認めた。その尾側では主膵管から分枝膵管に PanIN を認め、複数個所で
浸潤癌への移行像が見られ、膵頭部癌（pT1apN0cM0, pStage Ⅰ A）と診断確定した。
本症例では、明確な腫瘤像を欠く中で、膵管像の微細な変化と細胞診により術前に膵癌と診断し得た。術
前画像で膵癌の存在・局在を示唆しうる所見の有無について、後方視的な検討をお願いしたい。
`,
    link: "/case/p-5",
  },
  {
    caseid: "p-6",
    sessionid:"030",
    title: "11：00〜11：50　ポスター口演　［ Poster 2 ］（P-5〜P-8）",
    casetitle: "P-6   膵野型膵癌の一切除例",
    reader:"原　洋平（久留米大学 医学部 内科学講座 消化器内科部門）",
    members: `○原 洋平<sup>1）</sup>、谷川 雅彦<sup>2）</sup>、寺部 寛哉<sup>1）</sup>、吉村 壮平<sup>1）</sup>、阪上 尊彦<sup>1）</sup>、平井 真吾<sup>1）</sup>、赤司 昌謙<sup>4）</sup>、中山 正道<sup>2）</sup>、内藤 嘉紀<sup>2,3）</sup>、久下 亨<sup>4）</sup>
1）久留米大学医学部 内科学講座消化器内科部門、2）久留米大学医学部 病理学講座、
3）久留米大学病院 臨床検査部、4）久留米大学医学部 外科学講座肝胆膵外科部門
`,
    detail: `　72 歳, 女性。既往歴: 55 歳 乳癌術後放射線化学療法。69 歳 総胆管結石に内視鏡的治療。70 歳 胆嚢摘出術。現
病歴: 前医の腹部US で膵体部に11mm 大の腫瘤を指摘され当科へ紹介となった。当院の MRI では,T1W1や
T2W1 で病変を明確に同定できなかった。腹部 US, EUS では膵体部に 10mm 大の辺縁やや不整で境界明瞭
な低～無エコー腫瘤が描出され , 後方エコー増強は認めなった。主膵管狭窄は認めず膵腫瘤に対して厳重経
過観察とし , 3 ヶ月後に再評価を行った。ソナゾイド造影腹部 US では , 病変は早期より造影効果があり , 漸増性に膵実質と同等の造影効果を呈する充実性腫瘍が疑われた。造影 CT でも腫瘤は漸増性の造影効果を呈し, 尾側膵管拡張は伴わなかった。PET-CT では同部に異常集積は認めず, 画像所見より浸潤性膵管癌,神経内分泌腫瘍 , 腺房細胞癌 , 膵充実性偽乳頭状腫瘍が鑑別疾患として挙げられた。病変に対する EUS-TAで異型細胞を認めた。免疫組織化学では , INSM1, Synaptophysin 弱陽性 , chromogranin A 陰性 , CD56, Bcl-10 陰性 ,GATA3, Mammaglobin, GCDFP15 陰性で乳癌膵転移は否定的で浸潤性膵管癌を示唆する一方で , 神経内分泌腫瘍の除外はできなかった。膵体尾部切除術が施行した。病理組織学的に浸潤性膵管癌と診断した。検討項目 : 発癌以前の画像から膵癌の発生を予見しえるか , 画像検査および病理所見から膵野型膵癌に矛盾しないかを検討頂きたい。
`,
    link: "/case/p-6",
  },
  {
    caseid: "p-7",
    sessionid:"031",
    title: "11：00〜11：50　ポスター口演　［ Poster 2 ］（P-5〜P-8）",
    casetitle: "P-7   膵尾部の増大縮小を繰り返す嚢胞性病変の経過観察中に進行膵癌が生じ嚢胞破裂した1例",
    reader:"杉本　祥拓（藤枝市立総合病院消化器内科）",
    members: `○杉本 祥拓、大畠 昭彦、丸山 保彦、吉井 重人、景岡 正信、寺井 智宏、星野 弘典
藤枝市立総合病院 消化器内科
`,
    detail: `　【症 例】70 歳代男 性。X-5 年 10 月、1 型糖尿病精査時の MRCP で膵尾部に多房性嚢胞性病変 ( 最大
43mm) を認めた。EUS で嚢胞内部に充実成分はなかった。IPMN・仮性嚢胞を疑い、MRCP・EUS を 6 か
月毎交互にフォローした。嚢胞径は増大 ( 最大 81mm) と縮小 ( 最小 38mm) を繰り返したが、明らかな
充実性部分や壁肥厚、拡散抑制は認めなかった。X 年 7 月の CT でも悪性を疑う所見はなかったが、嚢胞
はわずかに増大したため、3 か月後フォローとした。同年 8 月、腹痛にて救急受診。CT で膵尾部嚢胞は
90mm へ著明増大し膵周囲に液体貯留を認めた。MRI で嚢胞内に拡散抑制を認めた。膵尾部仮性嚢胞破裂・膵癌合併疑いで膵体尾部切除術、胃・結腸部分切除術を施行した。術中、肉眼的には嚢胞を認めず、膵尾部に白色調腫瘤 (26mm) があり、胃・結腸への浸潤を認めた。腫瘤には内腔があり、病理組織学的に嚢胞壁に上皮はなく仮性嚢胞と診断された。嚢胞を裏装する高分化型膵管癌を認めた。免疫染色 (MUC1 陽性 / MUC2陰性 /MUC5AC 陽性 ) より膵実質由来の膵管癌の仮性嚢胞壁への浸潤と考えられた。S-1 で術後補助化学療法を 2 コース施行した。腹膜播種による癒着性腸閉塞等を生じ、X+ １年 5 月に永眠した。
【検討項目】膵仮性嚢胞への腫瘍の浸潤形態として内腔を裏装し得るか。膵尾部嚢胞は画像上仮性嚢胞の診断で良いか。
`,
    link: "/case/p-7",
  },
  {
    caseid: "p-8",
    sessionid:"032",
    title: "11：00〜11：50　ポスター口演　［ Poster 2 ］（P-5〜P-8）",
    casetitle: "P-8   嚢胞の経時的形態変化を伴った嚢胞性腫瘤の一例",
    reader:"船登　智將（亀田総合病院）",
    members: `○船登 智將<sup>1）</sup>、真口 宏介<sup>1,2）</sup>、中路 聡<sup>1）</sup>、白鳥 俊康<sup>1）</sup>、吉村 茂修<sup>1）</sup>、川満 菜津貴<sup>1）</sup>、西脇 拓郎<sup>1）</sup>、蘆川 尭<sup>1）</sup>、川添 夕佳<sup>1）</sup>、大野 航<sup>1）</sup>
1）亀田総合病院、2）手稲渓仁会病院 教育研究センター
`,
    detail: `　80 歳男性 . S 状結腸癌（12 年前）と転移性肝癌（12 年前）, 肺腺癌（6 年前）に対して手術歴あり． 術
後フォロー目的に施行した 3 年前の MRI で膵頭部に 8 mm の嚢胞を初回指摘されていた．嚢胞は増大傾向
であり，精査目的に当科紹介された．膵ダイナミック CT では，壁の一部に造影効果を有する嚢胞性病変で
あり，MRI では，明らかな拡散制限は伴わない T1WI 高信号・T2WI 等から低信号の多房性嚢胞性腫瘤であ
り，膵の限局性萎縮や主膵管径の拡張は認めなかった． EUS では嚢胞性腫瘤は微小嚢胞の集簇である蜂巣状構造（honey-comed appearance）と無エコー域が混在していた。SCN の可能性を考慮し短期経過観察の方針となった．2 ヶ月後の EUS フォローで辺縁に低エコー域を認めたため，同部位に対して EUS-TAを施行した．病理結果では Low-grade IPMN の診断であったため，CT・MRI・EUS での慎重経過観察となった . １年間のフォローで嚢胞径は 21 mm から 42 mm に増大し，膵酵素上昇を伴う主膵管拡張を認めたため，膵頭十二指腸切除術の方針となった . 切除検体の割面には，不規則な輪郭を持つ，様々な大きさの多房性嚢胞性病変が認められた．組織学的には , 細胞異型の弱い腫瘍細胞に裏打ちされた多数の拡張した管腔を特徴とする高分化腺癌であった．膵周囲脂肪組織および十二指腸壁に浸潤し, 線維性間質反応を伴っていた．リンパ管侵襲やリンパ節転移は認められなかった．また，神経周囲浸潤が広範囲に見られた .
`,
    link: "/case/p-8",
  },
  {
    caseid: "p-9",
    sessionid:"033",
    title: "11：00〜11：50　ポスター口演　［ Poster 3 ］（P-9〜P-12）",
    casetitle: "P-9   連続膵液細胞診陰性の3ヶ月後に膵癌が顕在化した一例",
    reader:"小出　香里（岐阜県総合医療センター）",
    members: `○小出 香里<sup>1）</sup>、丸田 明範<sup>1）</sup>、山内 和貴<sup>1）</sup>、吉田 健作<sup>1）</sup>、清水 省吾<sup>1）</sup>、岩下 拓司<sup>2）</sup>、清水 雅仁<sup>2）</sup>、小森 充嗣<sup>1）</sup>、片山 雅貴<sup>1）</sup>、野口 慶<sup>1）</sup>
1）岐阜県総合医療センター、2）岐阜大学医学部附属病院
`,
    detail: `　症例は 56 歳男性．心窩部痛の精査目的に当院紹介．軽症急性膵炎と診断し保存加療を行なった．造影
CT で尾側主膵管が軽度拡張し膵体部で追えなくなり，同部位の膵実質は限局性に萎縮していた．EUS では
膵管の caliber change 部位に 5 ＊ 5mm 大の境界不明瞭な低輝度な領域を認めたが穿刺対象となる腫瘍性病変は指摘できなかった．そのために，連続膵液細胞診 (SPACE) での精査を行った．膵管造影で膵体部に
5mm 程度の狭窄を認め，末梢膵管は7mm と拡張していた．狭窄部を超えて５Fr ENPD カテーテルを留置し，6 回の細胞診を提出するも全て陰性であった．しかし，高異型度上皮内腫瘍などの腫瘍性病変の狭窄を考慮し SPACE 実施 78 日後に再度 MRCP を実施した．MRCP で膵体部主膵管狭窄が延長，同部位に 15mm 大の腫瘤性病変を認めた．EUS で膵体部に 13 ＊ 11mm の境界明瞭な低エコーの腫瘤性病変を認め FNA を実施し，組織診では adenocarcinoma であった．以上から Pb,TS1(13mm) ,cT1c,CH0, cDU0 ,cS0 ,cRP0,cPV0,cA0,cPL0,cOO0,cN0,cM0 cStage Ⅰ A と診断し手術目的で外科へ紹介．術前化学療法として Gemcitabine plus S1 を 2 コース施行後に膵全摘術を行い，病理病期は pT3,pN1a,M0,fStage Ⅱ B/pT1c,ypN1,M0 fStage Ⅱ B であった．今回 SPACE 陰性であるも 3 ヶ月後に膵癌が顕在化した一例を経験した . SPACE 施行時の画像所見，細胞診所見，また陰性症例の取り扱いに関してご検討いただきたい．
`,
    link: "/case/p-9",
  },
  {
    caseid: "p-10",
    sessionid:"034",
    title: "11：00〜11：50　ポスター口演　［ Poster 3 ］（P-9〜P-12）",
    casetitle: "P-10   遠位胆管癌術後の残膵に通常型膵癌が生じた1例",
    reader:"平昭　衣梨（JA尾道総合病院　消化器内科）",
    members: `○平昭 衣梨<sup>1）</sup>、延藤 大樹<sup>1）</sup>、奥田 康博<sup>1）</sup>、平野 哲郎<sup>1）</sup>、清水 晃典<sup>1）</sup>、花田 敬士<sup>1）</sup>、田中 信治<sup>1）</sup>、大下 彰彦<sup>2）</sup>、米原 修治<sup>3）</sup>
1）JA 尾道総合病院 消化器内科、2）JA 尾道総合病院 外科、
3）JA 尾道総合病院 病理研究検査科
`,
    detail: `　症例は 73 歳男性。黄疸を主訴に近医から当院紹介。CT、EUS では膵腫瘤・膵管異常は指摘できず、遠位
胆管に片側性の壁肥厚と狭窄を認め、遠位胆管癌が疑われた。ERCP で胆管擦過細胞診・胆汁細胞診、
POCS で狭窄部の不整粘膜の生検を施行したが悪性所見を認めず胆管狭窄部の肥厚した胆管壁に対して
EUS-FNA を施行し、悪性を疑う異形腺細胞を少数検出した。PET-CT では明らかな遠隔転移なく、遠位胆管癌 T2N0M0StageIB の術前診断となり SSPPD を施行。術後病理では総胆管から十二指腸、膵頭部に浸潤性に増殖する高分化管状腺癌を認め、遠位胆管癌 pT3N0M0（Stage IIB）と診断した。また切除した膵頭部の分枝膵管に限局するHigh grade PanIN を認めた。術後化学療法として S-1 を半年間内服、術後 1 年 9 ヶ 月の造影 CT で残膵に 2cm 大の乏血性腫瘤を認め、PET-CT では同部から腹腔動脈に沿って異常集積を認めた。EUS-FNA では腺癌を検出。残膵に生じた通常型膵癌と診断し、GEM ＋ nab-PTX 併用療法を導入し加療中である。遠位胆管癌の病理診断の妥当性、High grade PanIN は分枝膵管に限局していたのか、胆管癌術前に膵上皮内癌を示唆する画像所見の有無などを検討して頂きたい。
`,
    link: "/case/p-10",
  },
  {
    caseid: "p-11",
    sessionid:"035",
    title: "11：00〜11：50　ポスター口演　［ Poster 3 ］（P-9〜P-12）",
    casetitle: "P-11   仮性動脈瘤を形成した破骨細胞を伴う退形成膵癌の一例",
    reader:"木村　優伽（愛媛県立中央病院）",
    members: `○木村 優伽、兼光 梢、加藤 佳夏子、村川 和也、宇都宮 健、黒田 太良、木藤 克己、宮田 英樹
愛媛県立中央病院
`,
    detail: `　【症例】55 歳、男性【主訴】腹痛【現病歴】20XX 年 1 月、腹痛を主訴に近医受診。膵頭部腫瘤を指摘され、2 月に精査加療目的に紹介受診した。【既往歴】44 歳 : 多発性嚢胞腎による末期腎不全で透析中、左視床出血【経過】血液検査では軽度の炎症反応上昇と腎機能障害があり、腫瘍マーカーの上昇はみられなかった。造影CT では膵頭部に 50mm 大の膨張性に発育する腫瘤性病変を認め、早期から不均一に造影され、辺縁に10mm 大の仮性動脈瘤、腹側には仮性嚢胞を伴っていた。仮性動脈瘤に対して塞栓術が施行された。 MRI ではT1WI で低信号の中に高信号が混在し、T2WI は隔壁構造を伴う高信号の嚢胞性病変、低信号の充実部分があり、一部拡散低下を示した。EUS では境界明瞭で不整な低エコー SOL で、内部は無エコーから高エコーと多彩な像を示した。PET-CT では充実部に FDG 集積 (SUV max=22.3) がみられた。低分化腺癌、粘液癌、退形成癌、腺房細胞癌、NEC などが疑われ、亜全胃温存膵頭十二指腸切除術が施行された。組織では核異型の強い紡錘形～多角形細胞が、多数の破骨型多核巨細胞を伴って充実性の増殖を示しており、腫瘍に隣接して凝血塊を貯留した仮性嚢胞を認めた。Anaplastic carcinoma with osteoclast-like giant cells T3N0M0 stage IIA (UICC-8th) と診断された。【結語】仮性動脈瘤を形成した破骨細胞を伴う退形成膵癌の一例を経験した。
術前画像検査での鑑別すべき点などを議論頂きたい。
`,
    link: "/case/p-11",
  },
  {
    caseid: "p-12",
    sessionid:"036",
    title: "11：00〜11：50　ポスター口演　［ Poster 3 ］（P-9〜P-12）",
    casetitle: "P-12   画像診断に苦慮した多血性膵腫瘤の一例",
    reader:"川添　夕佳（亀田総合病院　消化器内科）",
    members: `○川添 夕佳<sup>1）</sup>、中路 聡<sup>1）</sup>、真口 宏介<sup>1,2）</sup>、白鳥 俊康<sup>1）</sup>、吉村 茂修<sup>1）</sup>、川滿 菜津貴<sup>1）</sup>、西脇 拓郎<sup>1）</sup>、船登 智將<sup>1）</sup>、蘆川 尭<sup>1）</sup>、大野 航<sup>1）</sup>
1）亀田総合病院 消化器内科、2）手稲渓仁会病院 教育研究センター
`,
    detail: `　【症例】81 歳男性。12 年前に S 状結腸癌術後、4 年前に肝細胞癌（HCC）対して複数回の局所治療歴がある。近医で経過観察中、S8 に HCC の再発を指摘され、加療目的に当院再紹介された。dynamicCT で、膵頭部に辺縁部が早期濃染され内部は不均一な造影効果を伴う 26mm の腫瘍を認めた。4 年前の CT を見返すと同部位に 7mm の境界明瞭で早期濃染を呈する腫瘍を認めた。経過から NEN の増大を考えた。HCCに対して肝動脈化学塞栓術施行後、膵腫瘍に対して EUS-TA を施行した。EUS 観察では膵頭下部に 22mmの境界明瞭な低エコー腫瘤を認め NEN に矛盾しない所見であったが、病理検査では Synaptophysin、
Chromogranin A は陰性、Trypsin 弱陽性で膵腺房細胞癌（ACC）示唆された。ACC cStage Ⅰ B の術前診断
で、亜全胃温存膵頭十二指腸切除術を施行した。【考察】NEN は CT で境界明瞭、早期濃染を一般的に示すが、不整形、内部不均一な増強効果、早期濃染を認めない等の非典型例も存在し、悪性度との関連が示唆されている。一方で、ACC は CT で境界が比較的明瞭で内部に低濃度域を有し造影効果は低いことが知られる。本症例は CT 所見および経過から NEN を考えたが、ACC の術前診断であり非典型例と考えられた。
【ご討議いただきたい内容】4 年間で緩徐に増大する多血性腫瘍であり、画像所見からも NEN を第一に疑ったが、経過および術前画像検査から ACC を考える要素があったか、病理所見も典型的でなくご討議をお願いします。
`,
    link: "/case/p-12",
  },
  {
    caseid: "p-13",
    sessionid:"037",
    title: "11：00〜11：50　ポスター口演　［ Poster 4 ］（P-13〜P-15）",
    casetitle: "P-13   ITPNと鑑別を要したlow grade IPMN, gastric typeの一例",
    reader:"石原　朋和（和歌山県立医科大学　内科学第二講座）",
    members: `○石原 朋和<sup>1）</sup>、蘆田 玲子<sup>1）</sup>、三笠 友理奈<sup>2）</sup>、糸永 昌弘<sup>1）</sup>、山下 泰伸<sup>1）</sup>、田村 崇<sup>1）</sup>、川路 祐輝<sup>1）</sup>、四至本 貴大<sup>1）</sup>、北野 雅之<sup>1）</sup>
1）和歌山県立医科大学 内科学第二講座、2）和歌山県立医科大学 人体病理学教室
`,
    detail: `　症例は 70 歳代女性。早期胃癌に対する ESD 前精査の造影 CT にて、膵尾部に嚢胞性病変を指摘され、当
院へ紹介となった。造影 CT では、膵尾部に 20mm 大の乏血性腫瘤と隣接した嚢胞を認めた。MRI で腫瘤
は T1 低信号、T2 高信号を呈し、DWI では膵全体が高信号を示していたが、腫瘍に一致する拡散制限は認
めなかった。MRCP では完全型 divisum を認めた。EUS では、膵尾部主膵管内に充満する 11mm 大の等エ
コーの充実性腫瘤を認めた。ソナゾイド造影では早期から後期にかけて均一に染影された。病変は主膵管
内に限局していることより穿刺は施行しなかった。PET-CT では集積は認めず、腫瘍マーカーはいずれも陰
性であった。
以上より術前診断として ITPN を疑い、腹腔鏡下膵体尾部切除術を施行した。
術後病理検査では、主膵管内に増生する上皮性腫瘍を認め、低異型度の幽門腺様円形腺管が密在していた。免疫染色では、PAS 陽性の粘液細胞が広範囲にみられた。MUC-6、Fascin、CK17 は全体に陽性、MUC- 5ACおよび CK7 は一部に陽性を示した。MUC-1 および MUC-2 は陰性であった。p53 は弱陽性、MIB-1 陽性細胞は少数であった。最終診断は low grade IPMN, gastric type であった。
本症例の術前画像所見と切除標本の検討を踏まえ、術前に正確な診断が可能であったかについて議論を希
望する。
`,
    link: "/case/p-13",
  },
  {
    caseid: "p-14",
    sessionid:"038",
    title: "11：00〜11：50　ポスター口演　［ Poster 4 ］（P-13〜P-15）",
    casetitle: "P-14   膵全体に進展を認めた Intraductal tubulopapillary carcinomaの１例",
    reader:"後藤　尚希（大分市医師会立アルメイダ病院　消化器内科）",
    members: `○後藤 尚希<sup>1）</sup>、福地 聡士<sup>1）</sup>、半澤 誠人<sup>1）</sup>、草津 工喜<sup>1）</sup>、有木 晋平<sup>1）</sup>、白鳥 敏夫<sup>2）</sup>、松本 俊郎<sup>3）</sup>、和田 純平<sup>4）</sup>、水上 一弘<sup>5）</sup>、佐上 亮太<sup>5）</sup>
1）大分市医師会立アルメイダ病院 消化器内科、2）大分市医師会立アルメイダ病院 外科、
3）大分市医師会立アルメイダ病院 放射線科、4）大分市医師会立アルメイダ病院 臨床検査科、
5）大分大学 消化器内科学講座
`,
    detail: `　症例は 79 歳男性。X-1 年 5 月に２型糖尿病の血糖コントロールの悪化で近医より当院紹介され精査
目的に造影 CT 施行。右肺上葉の結節、膵管拡張、多房性嚢胞を指摘された。X-1 年 10 月に右上葉肺癌
cT1bN2M0 に対してカルボプラチン + アブラキサン１コース後、X 年 3 月に胸腔鏡下右上葉切除術 + リン
パ節郭清術が施行された（ypT1miNoM0, stage Ⅰ A1）。X 年 5 月の造影 CT にて膵頭部に不整形腫瘤の出
現及び主膵管拡張、主膵管内の濃染結節を認めた。MRI にて膵頭部～尾部に主膵管拡張及び主膵管内に多
発する乳頭状の結節を認めた。同多発結節は拡散強調像で高信号を呈しており拡散制限を認め、主膵管内
は脂肪抑制 T2 強調像での高信号に乏しく粘液産生に乏しいと考えられた。ERP で膵管内はほとんど造影
されず腫瘍で充満しているようであり、膵頭部の生検検体及び膵液細胞診から悪性腫瘍を疑う所見を認め
た。ITPC として X 年 12 月に膵全摘術が施行された。病理組織学的には、ほぼ全域の膵管内に壊死を伴う
非浸潤性の ITPC を認めた。免疫染色では腫瘍細胞は MUC6 陽性、MUC2 陰性、MUC5AC 陰性であった。
ITPN は非常に稀であり、膵管内腫瘍における割合は 3% と報告されている。今回、膵全体に進展してい
た ITPC の１例を経験したので報告する。病理診断の妥当性についてご検討いただきたい。
`,
    link: "/case/p-14",
  },
  {
    caseid: "p-15",
    sessionid:"039",
    title: "11：00〜11：50　ポスター口演　［ Poster 4 ］（P-13〜P-15）",
    casetitle: "P-15   術前診断が可能であった限局性膵萎縮を伴う微小な主膵管型膵管内乳頭粘液性腺癌の1例",
    reader:"住谷　秀仁（仙台市医療センター　仙台オープン病院　消化管・肝胆膵内科）",
    members: `○住谷 秀仁<sup>1）</sup>、越田 真介<sup>1）</sup>、菅野 良秀<sup>1）</sup>、小川 貴央<sup>1）</sup>、楠瀬 寛顕<sup>1）</sup>、酒井 利隆<sup>1）</sup>、及川 昌也<sup>2）</sup>、澤井 高志<sup>3）</sup>、野田 裕<sup>4）</sup>、伊藤 啓<sup>1）</sup>
1）仙台市医療センター仙台オープン病院 消化管・肝胆膵内科、2）仙台市医療センター仙台オープン病院 消化器外科、
3）仙台市医療センター仙台オープン病院 病理診断科、4）仙台市医療センター仙台オープン病院 健診センター
`,
    detail: `　症例は 80 歳女性．健診の腹部超音波検査で主膵管径 4mm と軽度拡張を指摘され，当科を受診した．
CT，MRCP では膵体部主膵管の狭窄，同部の膵実質の萎縮と分枝膵管の拡張を認めた．膵上皮内癌の可能
性を考慮したが，狭窄の前後ともに主膵管は軽度拡張していた．超音波内視鏡検査では，膵体部主膵管内に
微小な腫瘤構造が疑われた．ERCP では，膵頭部主膵管内に粘液を疑う透亮像を認め，膵体部主膵管には拡
張分枝の描出を伴う狭小化を認めた．管腔内超音波検査では，膵体部主膵管の狭窄部に一致して微小な膵管
内腫瘤を認めた．この際に主膵管狭窄部での生食洗浄下に回収した液体検体を用いて細胞診（セルブロック
法）を行った．HE 染色では，粘液を有する異型細胞からなる乳頭状の上皮組織を認め，Ki67 labeling
index（Ki67LI）高値，MUC2 陽性であり，腸型の膵管内乳頭粘液性腺癌（IPMC）が疑われた．画像上は微
小病変であるが，主膵管型 IPMC と術前診断し，膵体尾部切除術を施行した．切除標本の組織像は，膵体部
の軽度拡張した主膵管内を主体に，一部は分枝膵管内に広がる乳頭状の異型上皮を認めた．病変は膵体部主
膵管内に沿って 8mm 程に限局しており，非浸潤性であった．細胞診同様に Ki67LI 高値， MUC2 陽性であ
り，最終的に腸型の主膵管型 IPMC，非浸潤性（pTis，pN0，M0，pStage 0）と診断した．術後 2 年 6 か月無再発生存中である．
限局性膵萎縮を呈した主膵管型 IPMC の貴重な症例と考え報告する．
`,
    link: "/case/p-15",
  },
  {
    caseid: "p-16",
    sessionid:"040",
    title: "11：00〜11：50　ポスター口演　［ Poster 5 ］（P-16〜P-18）",
    casetitle: "P-16   鑑別困難なIPMNに由来する破骨細胞様巨大細胞を伴う未分化癌が混在する浸潤性膵管癌の1例",
    reader:"孝田　博輝（愛知県がんセンター）",
    members: `○孝田 博輝、桑原 崇通、羽場 真、奥野 のぞみ、松本 慎平、水野 伸匡、夏目 誠治、奥野 正隆、細田 和貴、原 和生
愛知県がんセンター
`,
    detail: `　症例は 60 代の女性。8 年前から膵体部の嚢胞性病変に対して 1 年毎にフォローされていたが、嚢胞の
増大と内部結節の出現で当科紹介となった。血液検査では特記所見認めないが、24mm 大の病変は MRI で
T2 強調像で高信号を呈し、病変内部には低信号結節を認め、主膵管との交通は指摘できなかった。DWI でも拡散制限は認めなかった。造影 CT では肥厚した嚢胞壁と嚢胞内結節が遷延性に造影された。EUS では Bモードで区域性に充実成分を認めたが、ペルフルブタン造影では cyst-in-cyst 様の隔壁と充実成分の一部にのみ造影効果を認め、大部分は出血変化が疑われた。MCN や嚢胞変性した膵神経内分泌腫瘍、SPN を疑い、周囲への腫瘍浸潤所見は認めないことから膵中央切除術を施行した。病理所見は、嚢胞内には GNAS 変異を有する high-grade dysplasia 相当の乳頭状増殖を示す粘液性上皮が裏打ちしており、一部嚢胞内への隆起を形成し、嚢胞壁には結節状に浸潤していた。同部位では破骨細胞様巨大細胞を伴う未分化癌と中分化
～低分化腺癌が混在しており、IPMN 由来の浸潤癌と診断した。尾側残膵追加切除並びにリンパ節郭清を
行い、pT1N0M0, pStage Ⅰ A（UICC8th）の最終病理診断となった。その後、腹膜播種再発を来たし、遺伝
子パネル検査で ETV6/NTRK3 融合遺伝子を認めたことからラロトレクチニブによる治療を継続中である。
本症例における術前診断と術式含めた治療方針について討議いただきたい。
`,
    link: "/case/p-16",
  },
  {
    caseid: "p-17",
    sessionid:"041",
    title: "11：00〜11：50　ポスター口演　［ Poster 5 ］（P-16〜P-18）",
    casetitle: "P-17   局在診断に難渋する間に膵管胆管瘻を形成し、外科的切除を行った膵管内乳頭粘液性腺癌の一例",
    reader:"北川　瑞希（長崎大学病院 消化器内科）",
    members: `○北川 瑞希<sup>1）</sup>、柴田 雅士<sup>1）</sup>、髙橋 孝輔<sup>1）</sup>、小澤 栄介<sup>1）</sup>、足立 智彦<sup>2）</sup>、岡野 慎士<sup>3）</sup>、宮明 寿光<sup>1）</sup>
1）長崎大学病院 消化器内科、2）長崎大学病院 移植・消化器外科、
3）長崎大学病院 病理診断科・病理部
`,
    detail: `　症例は 62 歳女性。主膵管径 20mm で造影される結節を伴わない主膵管型 IPMN に対し、本人の希望で厳重な経過観察を行っていた。9 ヶ月後、拡張した膵頭部主膵管が膵内胆管を圧排したことにより閉塞性黄疸と急性胆管炎を発症し、ERBD を施行した。処置時に採取した胆汁細胞診の結果は Class Ⅰ、膵液細胞診の結果は Class Ⅴ , Adenocarcinoma で IPMC と診断したが、造影 CT・MRCP・EUS において腫瘍の局在および範囲の同定は困難であった。PET-CT を撮像したところ、嚢状に拡張した膵頭部主膵管の表層に沿うように淡いFDG の集積があり、同部がIPMC の主病変であるものと診断した。外科的手術を調整する矢先、再度急性胆管炎を発症し、造影 CT と再 ERCP 中の造影・IDUS の所見から IPMC に伴う膵管胆管瘻と確定診断した。
連日の ENBD チューブを用いた洗浄にて胆管炎の改善を維持でき、亜全胃温存膵頭十二指腸切除術を施行し得た。術中・術後の合併症はなく、手術標本の病理診断は IPMC, Ph, TS2; i-TS, ductectatic type, pT1c, med, INFa, ly0, v0, ne0, mpd1(6.7mm), pCH0, pDU0, pS0, pRP0, pPV0, pA0, pPL0, pOO0, pPCM0, pBCM0,
pDPM0, R0, pN0 で、主膵管と総胆管の瘻孔部に腫瘍の浸潤はなかった。
【討論内容】各検査では明らかな造影結節として描出されない主膵管型 IPMN に由来する IPMC の局在診断・範囲診断において、PET-CT を診断根拠としたが妥当であったか。
`,
    link: "/case/p-17",
  },
  {
    caseid: "p-18",
    sessionid:"042",
    title: "11：00〜11：50　ポスター口演　［ Poster 5 ］（P-16〜P-18）",
    casetitle: "P-18   術後病理にてIPMA, 浸潤性膵管癌, 膵神経内分泌腫瘍の３病変を認めた一例",
    reader:"早川　宇宙（慶應義塾大学医学部　内科学 (消化器)）",
    members: `○早川 宇宙<sup>1）</sup>、堀部 昌靖<sup>1）</sup>、津崎 盾哉<sup>2）</sup>、横山 陽一<sup>2）</sup>、北郷 実<sup>3）</sup>、原 健祐<sup>4）</sup>、川崎 慎太郎<sup>1）</sup>、岩崎 栄典<sup>1）</sup>、金井 隆典<sup>1）</sup>
1）慶應義塾大学医学部 内科学（消化器）、2）慶應義塾大学医学部 放射線科学教室、
3）慶應義塾大学医学部 外科学（一般・消化器）、4）慶應義塾大学医学部 病理学教室
`,
    detail: `　症例は 82 歳女性 . 乳癌術後 , 脂質異常症 , 骨粗鬆症の既往がある . 6 年前より膵 IPMN にて健診での
MRCP にてフォローされていた . 今回 , MRCP にて膵体部主膵管内に T2 短縮を示す結節および膵尾部に末
梢膵管の拡張を伴う DWI 高信号を示す腫瘤が新たに認められ , 精査目的に当科紹介となった . 血中腫瘍マー
カーは陰性であったが , PET-CT では膵尾部腫瘤に集積を認めた . 超音波内視鏡検査 (EUS) では膵体部主膵
管内に高さ 3.2mm の管腔に突出する結節および膵尾部に径 10mm 大の低エコー腫瘤を認め , いずれもソナ
ゾイド造影で造影効果を呈した . これらの所見より IPMN および浸潤性膵管癌が疑われ , ロボット支援下膵
体尾部切除術を施行した . 病理学的には , 膵体部に胃型の膵管内乳頭粘液性腺腫 (IPMA), 膵尾部に高分化型
浸 潤 性 膵 管 癌 を 認 め た . さ ら に 膵 尾 部 癌 近 傍 に 2.5mm 大 の 神 経 内 分 泌 腫 瘍 (chromogranin A, synaptophysin, CD56, Glucagon 陽性 ) を偶発的に認めた . なお , 病理学的にこれらの病変間に移行像や衝突像は認められなかった . 本症例は術後病理にて IPMA, 膵癌 , 神経内分泌腫瘍 (NET) の 3 病変が認められた稀な症例である . 中でも NET は術前画像検査で想定されておらず , その診断可能性についてご討議いただきたい . また , NET と膵癌の関連性に関して , 画像および病理所見から検討いただきたい .
`,
    link: "/case/p-18",
  },
  {
    caseid: "p-19",
    sessionid:"043",
    title: "11：00〜11：50　ポスター口演　［ Poster 6 ］（P-19〜P-21）",
    casetitle: "P-19   術前に診断し得た膵癌に対するEUS-FNA後のneedle tract seedingの1例",
    reader:"藤井　佑樹（岡山大学病院）",
    members: `○藤井 佑樹、松本 和幸、佐藤 亮介、菊池 達也、松三 明宏、宮本 和也、内田 大輔、堀⼝ 繁、堤 康一郎、大塚 基之
岡山大学病院
`,
    detail: `　症例は 50 歳男性。心窩部痛を主訴に前医を受診し、腹部 US で膵腫瘤を指摘され紹介となった。造影
CT で膵体部に 35mm の乏血性腫瘤を認め、経胃的に EUS-FNA を行い（21G 針、2 回穿刺）、腺癌と診断された。画像上は切除可能膵癌であったが、CA19-9 高値であり、Biological BR と考え GEM+nabPTX で NAC導入した。2 コース後に薬剤性肺障害を発症し、同時点で手術の方針となったが、腹膜播種のため試験開腹となった。その後 FOLFIRINOX を導入して、原発巣が縮小し、画像上播種病変を認めず、腫瘍マーカーも陰性化したため、導入 8 ヶ月後に外科と協議し、conversion surgery の方針となった。術前の CT で、初診時に認めない膵腫瘍と胃壁の間の線状軟部陰影を認めた。EUS で同部位は膵腫瘍から胃壁まで連続する低エコー領域であり needle tract seeding(NTS) が疑われた。そのため膵体尾部切除及び胃部分切除を予定術式とした。手術時に播種病変を認めず、洗浄細胞診も陰性であり手術を続行した。術中所見では FNA穿刺ルートに沿って、膵臓と胃壁に癒着があり、同部位を部分切除した。術後病理では主病変から胃漿膜側に連続する線維化を伴う腫瘍細胞の浸潤所見を認め NTS と診断した ( 膵体部癌 T3N1bM1Stage Ⅳ )。術後に胃壁に出現する NTS 画像は周知されてきたが、術前に指摘し得た NTS 画像は少なく、NAC が標準治療である現在では重要な所見と考える。本症例において、術前画像で NTS と診断してよいかご討議いただきたい。
`,
    link: "/case/p-19",
  },
  {
    caseid: "p-20",
    sessionid:"044",
    title: "11：00〜11：50　ポスター口演　［ Poster 6 ］（P-19〜P-21）",
    casetitle: "P-20   EUS-FNAによるNeedle Tract Seeding（NTS）が胃粘膜下嚢胞の形態を呈したIPMN由来浸潤癌の1例",
    reader:"三輪　峻大（成田記念病院　消化器内科）",
    members: `○三輪 峻大<sup>1）</sup>、山雄 健次<sup>1）</sup>、市田山 宝<sup>1,4）</sup>、外山 貴洋<sup>1）</sup>、山本 和弘<sup>1）</sup>、成田 真<sup>1）</sup>、坪井 謙<sup>2）</sup>、沢井 博純<sup>2）</sup>、桐山 諭和<sup>3）</sup>、山内 一訓<sup>1,4）</sup>
1）成田記念病院 消化器内科、2）成田記念病院 外科、
3）成田記念病院 病理診断科、4）名古屋大学 消化器内科
`,
    detail: `　【症例】78 歳、男性。【主訴】特になし。【既往歴】高血圧、緑内障、尿管結石、痛風、前立腺癌、脳動脈瘤。【現病歴】20XX 年 2 月、膵尾部 IPMN に連続する約 9mm の腫瘤に対し、25G 穿刺針を用いて経胃的 EUS-FNA（穿刺回数：1 回）を施行し、膵尾部 IPMN 由来の浸潤癌と診断した。翌 3 月に脾合併膵体尾部切除術を実施し、術後化学療法として一次治療の S-1 療法を半年間施行した。しかし右下葉に肺転移を認め、二次治療の Gem ＋ nab-PTX 併用療法を継続していた。術後 1 年 9 ヶ月後に CA19-9 の上昇を認め、造影 CT にて胃体中部に約 20mm の嚢胞様の胃粘膜下腫瘍（以下、SMT）を認めた。上部消化管内視鏡（EGD）では、25mm 大の正常粘膜に覆われた SMT を確認。超音波内視鏡（EUS）では第 3 層を主座とし、壁肥厚を伴う嚢胞性腫瘤を認めた。造影 EUS では壁肥厚部に造影効果を認めたため、同部に対して再度 EUS- FNA を実施し悪性と診断された。以上より、IPMN 由来浸潤癌の NTS による胃壁転移と診断し、術後 1 年 12 ヶ月後に腹腔鏡下胃部分切除術を施行。病理診断は、IPMN 浸潤癌のNTS に矛盾しない所見であった。【考察】EUS-FNA後の NTS 発生率は約 0.3% と報告されており、そのすべてが膵体尾部腫瘍を経胃的に穿刺した後、胃壁への再発として認められている。大多数は充実性の SMT として発現するが、本症例のように嚢胞性形態を呈した症例は極めて稀であるため報告した。
`,
    link: "/case/p-20",
  },
  {
    caseid: "p-21",
    sessionid:"045",
    title: "11：00〜11：50　ポスター口演　［ Poster 6 ］（P-19〜P-21）",
    casetitle: "P-21   混合型肺腺癌の術後に膵・腎転移を呈し、膵原発NETとの鑑別を要した一例",
    reader:"上田　剛（産業医科大学　第３内科学）",
    members: `○上田 剛<sup>1）</sup>、大江 晋司<sup>1）</sup>、宮川 恒一郎<sup>1）</sup>、梶谷 健太<sup>1）</sup>、篠原 暢彦<sup>1）</sup>、中村 光一<sup>2）</sup>、内原 大樹<sup>2）</sup>、島尻 正平<sup>2）</sup>、原田 大<sup>1）</sup>
1）産業医科大学 第３内科学、2）産業医科大学病院 病理診断科・病理部
`,
    detail: `　【症例】74 歳 女性
【主訴】なし
【経過】
70 歳時に右上葉肺腺癌（pT2aN0M0, Stage IB）に対し手術を施行された。術後補助療法は希望されず、
経過観察の方針となった。72 歳時の CT 検査で膵体部に 15mm 大の輪郭不明瞭な乏血性腫瘤を認め、右腎
にも同様の造影効果を呈する 10 ～ 15mm 大の腫瘤を複数認めた。FDG-PET/CT では膵腫瘍に異常集積を
認めたが、SRS では膵を含め、集積は認めなかった。EUS で膵腫瘍は輪郭不明瞭、辺縁不整な低エコー腫
瘤として描出され、EUS-TA にて AE1/AE3（+）、Synaptophisin（+）、Chromogranin A（focal +）、TTF1
（-）、NapsinA（-）、Ki67-index: 2％であり NET G1 と診断された。腎腫瘍生検では、Synaptophisin（+）、Chromogranin A （ + ）、TTF1（-）、NapsinA（-）、CD7 （+）、CD20（-）、p53（focal + ）、SSTR2A（-）、Ki67-index: 17％であり NET G2 と診断された。肺癌切除標本を再検討したところ、病変の約 10% の領域において Synaptophysin（+）、INSM1（+）で、Large cell neuroendocrine carcinoma (LCNEC) を疑う所見を認めた。肺病変、腎病変のいずれからも KRAS G12V 変異が認められた。各腫瘍の病理所見に差異はあるものの、combined-LCNEC の術後転移再発と診断し、化学療法を開始した。
【検討項目】
膵、腎病変を契機に精査を行い、combined-LCNEC の再発と診断した一例である。各病変が同一腫瘍に由
来するかどうか、病理学的なご検討をいただきたい。
`,
    link: "/case/p-21",
  },
  {
    caseid: "p-22",
    sessionid:"046",
    title: "11：00〜11：50　ポスター口演　［ Poster 7 ］（P-22〜P-25）",
    casetitle: "P-22   増大傾向にあった膵尾部単房性嚢胞に対して外科切除を施行した1例",
    reader:"藤崎　敬太（国立がん研究センター中央病院　肝胆膵内科）",
    members: `○藤崎 敬太<sup>1）</sup>、肱岡 範<sup>1）</sup>、永塩 美邦<sup>1）</sup>、原井 正太<sup>1）</sup>、山重 大樹<sup>1）</sup>、小森 康寛<sup>1）</sup>、海野 良介<sup>2）</sup>、江崎 稔<sup>2）</sup>、平岡 伸介<sup>3）</sup>、奥坂 拓志<sup>1）</sup>
1）国立がん研究センター中央病院 肝胆膵内科、2）国立がん研究センター中央病院 肝胆膵外科、
3）国立がん研究センター中央病院 病理診断科
`,
    detail: `　症例は 86 歳女性．X － 7 年に膵嚢胞の精査目的で紹介となった．飲酒歴，外傷歴や手術歴はなかった．
造影 CT では内部は均一な低吸収を呈する 20mm の単房性嚢胞を認め，早期相で壁が濃染し，主膵管に拡張や途絶は指摘できなかった ．MRCP では嚢胞性病変と主膵管との交通は明らかではなく，MRI では T2強調画像で水と等信号の高信号を呈し，明らかな充実成分はなかった．EUS では嚢胞壁は薄く，内部に壁構造を指摘できず，閉塞起点となるような腫瘍や主膵管の拡張はなかった．以上より，診断として MCN を第一に考え，鑑別として分枝型 IPMN 挙げた．年齢ならびに嚢胞径 <30mm であること、内部に充実部分を認めないことから，経過観察の方針とした。1 年ごとに造影 CT で経過観察を行ったところ、嚢胞が経時的に増大し，X 年には 30mm 大となったため，ロボット支援下膵尾部切除術を施行した．マクロでは粘稠度の低い透明液を内包する単房性嚢胞で充実成分は確認できなかったが，病理学的に壁の内腔から壁内にかけて腫瘍細胞の増殖を認めた．免疫染色では Chromogranin A（+），Synaptophysin（+），Ki-67 標識率 1％であり，purely cystic NEN（G1）と診断された．purely cystic NEN は MCN との鑑別が問題となる．本症例では，造影 CT で嚢胞壁が早期相で濃染する所見が認められ，多血性腫瘍が示唆される．この所見から，画像段階でNEN の可能性を想起し得たかどうかについて討論したい．
`,
    link: "/case/p-22",
  },
  {
    caseid: "p-23",
    sessionid:"047",
    title: "11：00〜11：50　ポスター口演　［ Poster 7 ］（P-22〜P-25）",
    casetitle: "P-23   膵体尾部脂肪置換を呈した膵神経内分泌腫瘍の1例",
    reader:"松本　昂（九州大学病院　形態機能病理学）",
    members: `○松本 昂<sup>1）</sup>、山本 猛雄<sup>1）</sup>、筬島 哲<sup>1）</sup>、中西 芳之<sup>1）</sup>、野口 彰子<sup>1）</sup>、渡邊 雄介<sup>2）</sup>、相島 慎一<sup>3）</sup>、中村 雅史<sup>2）</sup>、小田 義直<sup>1）</sup>
1）九州大学病院 形態機能病理学、2）九州大学病院 臨床・腫瘍外科、
3）九州大学病院 構造病態病理学
`,
    detail: `　50 歳男性. 健康診断の腹部超音波検査で膵体部腫瘤を指摘された. 造影CT では膵頭体部移行部に 12mm大の遷延性造影効果を示す腫瘤を認め , EUS-FNA により膵神経内分泌腫瘍 (pancreatic neuroendocrine
tumor: pNET) と診断された . 同時に , 膵体尾部に約 7 cm にわたる著明な萎縮がみられ , 膵低形成あるいは脂肪置換が疑われた . 膵機能を温存するためロボット支援下脾動静脈温存膵体尾部切除術を施行した . 術中所見では , 膵頭体部移行部に 10mm 大の低エコー領域を認め , 膵体尾部は脂肪組織へ置換されていた .病理組織学的には , 線維化を伴う間質を背景に小型円形～卵円形の腫瘍細胞が増殖しており , 免疫染色で
Synaptophysin, Chromogranin A, serotonin が陽性であったことから , 非機能性セロトニン陽性 pNET と診断した . 腫瘍による主膵管閉塞に加え , 腫瘍尾側では広範な萎縮が認められたことから , 主膵管閉塞に伴う慢性膵炎が萎縮の原因と推察された . 膵低形成も鑑別に挙がる膵体尾部脂肪置換を伴った pNET の稀な 1例を経験したため文献的考察を加えて報告する .
`,
    link: "/case/p-23",
  },
  {
    caseid: "p-24",
    sessionid:"048",
    title: "11：00〜11：50　ポスター口演　［ Poster 7 ］（P-22〜P-25）",
    casetitle: "P-24   アミロイド沈着を伴う多発膵神経内分泌腫瘍を認めたMEN１の1例",
    reader:"重松　慶一（九州大学大学院医学研究院　臨床・腫瘍外科）",
    members: `○重松 慶一<sup>1）</sup>、阿部 俊也<sup>1）</sup>、松本 昂<sup>5）</sup>、石松 慶祐<sup>2）</sup>、藤森 尚<sup>3）</sup>、石神 康生<sup>2）</sup>、相島 慎一<sup>4）</sup>、小田 義直<sup>5）</sup>、中村 雅史<sup>1）</sup>
1）九州大学大学院医学研究院 臨床・腫瘍外科、2）九州大学大学院医学研究院 臨床放射線科学、
3）九州大学病院 肝臓・膵臓・胆道内科、4）九州大学大学院医学研究院 構造病態病理学、5）九州大学大学院医学研究院 形態機能病理学
`,
    detail: `　症例は 34 歳の男性．健診の腹部超音波検査で膵尾部に腫瘤を認め前医紹介となった．前医で膵腫瘤に対
して EUS-FNA を複数回施行されたが診断に至らず，精査加療目的に当院紹介となった．血液検査では，軽
度の高カルシウム血症を認めたが，腫瘍マーカーや内分泌マーカーに異常所見を認めなかった．造影 CTでは，膵尾部に遅延性に増強される境界明瞭な 4cm の腫瘤を認め，膵体部や膵頭部にも複数の多血性結節を認めた．造影 MRI では，膵尾部の腫瘤は辺縁から緩徐に遅延性に増強され，ソマトスタチン受容体シンチグラフィーで有意な集積はなく，FDG-PET/CT では膵尾部腫瘤に SUVmax=3.1 と軽度の集積を認めた． EUS では，膵尾部に 35mm の境界明瞭・類円形で辺縁血流の目立つ低エコー腫瘤を認め，膵頭部～体部には 4 ～ 6mm の多発低エコー腫瘤を認めた．膵尾部腫瘤に対する EUS-FNA による組織診では好酸性組織内にわずかに異形細胞を認め神経内分泌腫瘍が疑われたが確定診断は困難であった．膵頭部および体部の腫瘤は EUS-FNA による組織診で神経内分泌腫瘍の診断となり，また遺伝子検査の結果 MEN1 と診断された．多発膵神経内分泌腫瘍に対して膵体尾部切除術を施行した．最終診断は膵神経内分泌腫瘍（G1）で，細胞周囲の好酸性の無構造組織は Dylon 染色で橙色を呈し，アミロイド沈着を伴っていた．膵尾部の遅延性増強を示す神経内分泌腫瘍について，画像所見と組織学的特徴との関連について，ご討論いただきたい．
`,
    link: "/case/p-24",
  },
  {
    caseid: "p-25",
    sessionid:"049",
    title: "11：00〜11：50　ポスター口演　［ Poster 7 ］（P-22〜P-25）",
    casetitle: "P-25   経過観察中に上流主膵管拡張の消退、再出現がみられた膵神経内分泌腫瘍の1例",
    reader:"西山　秀（JA長野厚生連　佐久総合病院　佐久医療センター）",
    members: `○西山 秀、比佐 岳史、江郷 晶、宮坂 尚樹、坂田 正梧、伊藤 唯、工藤 彰治、山田 崇裕、大瀬良 省三、福島 秀樹
JA 長野厚生連佐久総合病院 佐久医療センター
`,
    detail: `　【症例】50 歳台、女性。X-8 年、肝機能障害の精査目的に施行した MRI で膵頭体移行部の主膵管狭窄と上流主膵管の軽度拡張を認めた。US、EUS で膵頭部に径 6mm、比較的境界明瞭でやや不整な類円形低エコー腫瘤を認め、腫瘤上流側の主膵管は 3mm と軽度拡張していた。造影 CT では腫瘤は動脈相で強く造影され、門脈相・遅延相で造影効果が遷延していた。ERP では膵頭体移行部の主膵管狭窄と上流主膵管の軽度拡張を認めた。膵液細胞診で異型細胞はみられなかった。線維化を伴う膵神経内分泌腫瘍と診断し、手術を提案したが経過観察を希望された。X-5 年までは 6 カ月毎に US、1 年毎に造影 CT および単純 MRI フォローを行い、腫瘤および主膵管狭窄に著変はみられなかったが、主膵管拡張は消退した。X-5 年から X-3 年まで 1年毎に US および単純 MRI フォローを行い、著変がみられなかったため近医に紹介し、以後は US で年 1 回フォローされていた。X 年の US で主膵管が 7mm と高度に拡張したため、当科に再紹介となった。 US、EUS、造影 CT、単純 MRI では拡張起始部の腫瘤の径や形態に著変はみられなかった。線維化を伴う膵神経内分泌腫瘍と診断し、膵頭十二指腸切除術を施行した。病理組織学的には、豊富な線維化を伴う膵神経内分泌腫瘍 (G1) であり、軽度のリンパ管侵襲を認めた。
    【討論したいポイント】腫瘍の径や形態に著変がみられなかったにもかかわらず、上流主膵管拡張の消退、再出現がみられた理由について検討したい。
`,
    link: "/case/p-25",
  },
  {
    caseid: "p-26",
    sessionid:"050",
    title: "11：00〜11：50　ポスター口演　［ Poster 8 ］（P-26〜P-28）",
    casetitle: "P-26   悪性腫瘍の合併が否定できず切除した膵SCNの1例",
    reader:"木村　元（新東京病院　消化器内科）",
    members: `○木村 元<sup>1）</sup>、浅原 新吾<sup>1）</sup>、青山 絋希<sup>2）</sup>、小玉 祐<sup>1）</sup>、西澤 秀光<sup>1）</sup>、外山 雄三<sup>1）</sup>、堀口 慎一郎<sup>3）</sup>、飯田 拓<sup>2）</sup>、溝上 裕士<sup>1）</sup>、長浜 隆司<sup>1）</sup>
1）新東京病院 消化器内科、2）新東京病院 外科、
3）がん・感染症センター都立駒込病院 病理科
`,
    detail: `　症例は 70 代男性。S 状結腸癌の術前検査で偶発的に膵体尾部腫瘤を指摘され、精査目的に当科受診と
なった。腹部造影 CT で膵体尾部に内部が周囲と比較して造影される腫瘤と尾側主膵管拡張を認めた。腹部
MRI では、同部位は T1 で低信号、T2 で高信号であり、拡散低下は認めなかった。膵頭部には IPMN を認めた。また、EUS では膵体尾部に 13mm 大の内部に石灰化を伴う均一な低エコー腫瘤と、その頭側に接して多数の無エコー域を伴う 20mm 大の腫瘤を認め、2 つの腫瘤の頭側と尾側には debris を伴う嚢胞を認めた。造影 EUS では腫瘤は早期から造影効果を認めた。EUS-FNA と ERCP による膵液細胞診の病理診断は SCN を疑うものであったが、画像上 NET や IPMN 併存癌の合併を否定できず、膵体尾部切除術を施行した。術後病理では、膵体尾部に 30mm 大の、内部が蜂巣状の境界明瞭な腫瘤を認め、組織学的に PAS 陽性のグリコーゲンを含む淡明な細胞質と類円形腫大核を持つ腫瘍細胞が、中小不揃いな嚢胞を形成して密に増殖し、蜂巣状の構造を認めていた。病変の中心部は硬化性変化を伴い、硝子化を伴う間質が広く介在していた。免疫染色では、上皮は MUC6 陽性、inhibitin 陽性だった。以上より Microcystic type の SCN と診断した。本症例において画像所見より NET や IPMN 併存癌の合併がない SCN と診断可能かご討議いただきたい。
`,
    link: "/case/p-26",
  },
  {
    caseid: "p-27",
    sessionid:"051",
    title: "11：00〜11：50　ポスター口演　［ Poster 8 ］（P-26〜P-28）",
    casetitle: "P-27   膵尾部に発生したリンパ上皮性嚢胞の一例",
    reader:"加藤　佳夏子（愛媛県立中央病院）",
    members: `○加藤 佳夏子、兼光 梢、村川 和也、黒田 太良、花岡 潤、木藤 克己、宮田 英樹
愛媛県立中央病院
`,
    detail: `　【症例】88 歳、男性。【主訴】なし。【現病歴】20XX-1 年 10 月、定期検査の腹部超音波検査にて腹部腫
瘤を指摘された。精査目的に 20XX 年 3 月、当院に紹介された。【経過】血液生化学検査では、CA19-9
524.5、SPAN-1 117.9 と上昇がみられた。造影 CT では膵尾部に接する 73*55*60 mm 大の境界明瞭な多
房性嚢胞性腫瘤をみとめた。腫瘤は被膜様構造をもち、一部小嚢胞が突出し、嚢胞隔壁は造影された。嚢
胞内は不均一に高吸収域だが、明らかな造影効果は指摘できなかった。MRI では T1WI で周囲膵実質と等
信号～軽度高信号で、in-phase から opposed phase で不均一な信号低下があり、微小な脂肪成分の存在が
疑われた。T2WI は高信号と低信号が混在していた。大部分が DWI 高信号、ADC 値低下を示し、中心部は拡散低下を示さない部位もみられた。EUS では被膜は薄く、内部は不均一なエコー輝度を呈しており、一部石灰化を伴う粗大貯留物の存在が疑われた。半年の経過で腫瘤に増大はみられなかったが、類表皮嚢胞が
疑われ、ロボット支援下腹腔鏡下膵体尾部切除術が施行された。膵体尾部に 67*61mm 大の多房性嚢胞が
あり、嚢胞内腔は単層～重層化した扁平上皮に覆われ、嚢胞内には多量に角化物やゼラチン様物質が貯留
していた。嚢胞壁にはリンパ濾胞の構築を伴うリンパ組織がみられ、リンパ上皮性嚢胞と診断された。
【結語】リンパ上皮性嚢胞の一例を経験した。術前画像検査での鑑別すべき点などを議論頂きたい。
`,
    link: "/case/p-27",
  },
  {
    caseid: "p-28",
    sessionid:"052",
    title: "11：00〜11：50　ポスター口演　［ Poster 8 ］（P-26〜P-28）",
    casetitle: "P-28   膵癌との鑑別を要した膵神経鞘腫の1例",
    reader:"長谷川　浩之（地域医療機能推進機構山梨病院）",
    members: `○長谷川 浩之、深澤 光晴、小澤 俊一郎、若尾 聡士、白勢 大門、武田 健二郎
地域医療機能推進機構山梨病院
`,
    detail: `　60 歳代男性。高血圧、脳出血、脂質異常症、胆嚢結石の既往あり。健診の腹部超音波検査にて膵頭部に
腫瘤を指摘され、前医を受診した。造影 CT では膵頭部に 12mm 大の腫瘤を認め、膵実質相で低吸収、遅延相で高吸収となる遅延性濃染像を呈していた。MRI では、T1 強調画像で低信号、T2 強調画像で高信号、拡散強調画像では拡散制限を認め、膵癌が疑われた。EUS-TA が試みられたが穿刺困難であり、当院に紹介された。
当院で施行した EUS では、腫瘤は高エコーの被膜を有し、境界明瞭かつ輪郭整の低～等エコー腫瘤と
して描出され、内部に小無エコー領域を認めた。EUS 所見から膵癌は否定的と考えられ、神経内分泌腫
瘍が鑑別に挙がった。EUS-FNB（22G）を施行し、病理組織学的に紡錘形細胞の増殖を認め、免疫染色で
S-100 陽性であったことから、膵神経鞘腫と診断された。
神経鞘腫は Schwann 細胞由来の良性腫瘍であり、膵臓に発生するのは極めて稀である。造影 CT では早
期相で低吸収、遅延相で濃染が増強する漸増性の造影効果を呈するため、膵癌との鑑別が重要である。確
定診断には EUS-TA による病理診断が不可欠であり、本症例では EUS-FNB により膵神経鞘腫と診断された
ことで、手術を回避することができた。
`,
    link: "/case/p-28",
  },
  {
    caseid: "p-29",
    sessionid:"053",
    title: "11：00〜11：50　ポスター口演　［ Poster 9 ］（P-29〜P-31）",
    casetitle: "P-29   黒色便を契機に診断された胆嚢癌肉腫の一例",
    reader:"田中　秀和（近畿大学病院）",
    members: `○田中 秀和、栗本 真之、山﨑 友裕、竹中 完
近畿大学病院
`,
    detail: `　症例は 81 歳男性。20XX 年 X 月 X 日に黒色便を主訴にかかりつけ医を受診し、貧血の進行認めたため
翌日に当院に紹介となり、同日入院となった。
上下部消化管内視鏡検査と小腸カプセル内視鏡検査が施行されるも出血源は認めなかった。食事を再開
したところ、発熱、腹痛および血液検査で肝機能障害を認め、単純 CT を施行すると遠位胆管に結石と考
える高輝度病変を認め、上流の胆管拡張を伴うことから胆管結石性胆管炎が疑われた。また、胆嚢内に 20
㎜のやや高吸収な腫瘤を認めた。これらの精査目的で EUS を施行し、遠位胆管に 8.8mm の音響陰影を伴う結石を認めた。胆嚢病変は、B-mode で底部に 24.7*18.1mm 大の境界不明瞭で内部不均一な隆起性病変として描出された。ソナゾイドでの造影 EUS で造影早期相では腫瘤への流入血管に irregular 所見を認め、造影後期相では腫瘤全体は heterogeneous パターンを呈した。腫瘤が接する胆嚢壁に造影効果の途絶はなく、漿膜浸潤は否定的であった。
胆嚢腫瘤は悪性の可能性が疑われ、外科にて X+35 日に腹腔鏡下胆嚢摘出術が施行された。病理検索では、
病変は胆嚢底部にある 25mm の隆起性病変であり、腫大した異型核を有する腺管状や充実性構造を呈する領域と骨形成や硝子化した膠原繊維がみられる領域が併存し、胆嚢癌肉腫（Stage Ⅱ）の診断に至った。病変の一部にびらんを認め、出血後変化と考えられた。
胆嚢癌肉腫は稀な疾患であり術前画像と病理所見の比較も含め報告する。
`,
    link: "/case/p-29",
  },
  {
    caseid: "p-30",
    sessionid:"054",
    title: "11：00〜11：50　ポスター口演　［ Poster 9 ］（P-29〜P-31）",
    casetitle: "P-30   胆管狭窄を初発とし術前診断が困難であった十二指腸癌の一例",
    reader:"古田　朗人（九州大学大学院医学研究院　病態制御内科学）",
    members: `○古田 朗人<sup>1）</sup>、村上 正俊<sup>1）</sup>、藤森 尚<sup>1）</sup>、野口 彰子<sup>2）</sup>、山本 猛雄<sup>2）</sup>、相島 慎一<sup>3）</sup>、池永 直樹<sup>4）</sup>、石神 康生<sup>5）</sup>、中村 雅史<sup>4）</sup>、小川 佳宏<sup>1）</sup>
1）九州大学大学院医学研究院 病態制御内科学、2）九州大学大学院医学研究院 形態機能病理学、
3）九州大学大学院医学研究院 構造病態病理学、4）九州大学大学院医学研究院 臨床・腫瘍外科、
5）九州大学大学院医学研究院 臨床放射線科学
`,
    detail: `　症例は 73 歳男性。肝機能障害を伴う遠位胆管狭窄に対して前医で内視鏡的逆行性胆管膵管造影（ERCP）を複数回施行されたが診断に至らず、精査加療目的に当院紹介となった。十二指腸乳頭部癌・遠位胆管癌・
膵頭部癌を鑑別に挙げ、ERCP、乳頭部生検、および超音波内視鏡下組織採取法により繰り返し細胞診およ
び組織診を施行したが、明確な悪性所見は得られず、腫瘍マーカーや IgG4 値にも異常所見を認めなかった。良性狭窄を疑い金属ステントの一時留置により胆管狭窄は一旦改善したが、初診から 21 か月後に胆管狭窄の再増悪と新たに十二指腸下行部の狭窄が出現した。依然として明確な悪性細胞は検出されなかったが、経過からは悪性腫瘍の十二指腸浸潤を考え、膵頭十二指腸切除術を施行した。術後病理検査は原発性進行十二指腸癌（pT4, pN1, cM0, 病期 III A）で、腫瘍は十二指腸の粘膜下層を中心に、筋層から漿膜にまで浸潤していた。胆管、膵臓、乳頭部への浸潤を認めたが腫瘍細胞が正常粘膜内に散在しており、また、腫瘍細胞の異型が弱い一方で繰り返す胆管炎による修飾もあり、術前診断が困難であったと考える。
組織採取法の工夫で術前診断の可能性を上げることができたかどうか、また術前の画像所見や病理像を
踏まえ手術のタイミングが適切であったかどうか、ご討論いただきたい。
`,
    link: "/case/p-30",
  },
  {
    caseid: "p-31",
    sessionid:"055",
    title: "11：00〜11：50　ポスター口演　［ Poster 9 ］（P-29〜P-31）",
    casetitle: "P-31   膵頭部近傍に発生した後腹膜腫瘤の1例",
    reader:"青田　紗季（四日市羽津医療センター）",
    members: `○青田 紗季、中島 滋人、面谷 卓馬、宮尾 遼、森田 翔一、阪⼝ 亮平、坪井 順哉、樋⼝ 国博、長谷川 浩司
四日市羽津医療センター
`,
    detail: `　40 代男性、右側腹部痛・血尿を主訴に当院泌尿器科を受診して右尿管結石症と診断された。その際に撮
影された腹部 CT で膵頭部近傍に粗大石灰化を伴う長径約 5cm の軟部腫瘤を認めたため、当科へ紹介となった。血液検査では特記所見なく、腹部エコーでは石灰化を伴った血流のある低エコー腫瘤として描出された。ダイナミック CT では膵に類似した造影パターンを示し、周囲に被膜様構造を伴う腫瘤として認識され、異所性膵が疑われる所見であった。MRCP では T1 low、T2 slight high、DWI high、ADC map lowを示し、膵実質とは異なっていたことから、孤立性線維性腫瘍 /GIST/ 肉腫 / 神経原性腫瘍 / リンパ腫などが鑑別に挙がった。EUS では 37mm × 27mm 大の境界明瞭、内部不均一な低エコー腫瘤として描出され、内部・辺縁共に血流は豊富であった。後日 EUS-TA を施行したが、上皮成分や紡錘形細胞等の腫瘍性所見は認めず、異型のない少量のリンパ球を認めるのみであった。以上より術前診断としては炎症性もしくは低悪性度の腫瘍性リンパ節腫大と考えたが、PET にて SUVmax 4.8 程度の軽度集積が認められたこともあり、確定診断目的に外科的切除を施行した。病理検査では腫瘤は腫大した単一のリンパ節で、胚中心の萎縮と濾胞の拡大、onion skinning 状のリンパ球の増生、硝子化血管の胚中心への侵入が認められ、単中心性 Castleman 病硝子血管型と診断した。
`,
    link: "/case/p-31",
  },
  {
    caseid: "p-32",
    sessionid:"056",
    title: "11：00〜11：50　ポスター口演　［ Poster 10 ］（P-32〜P-34）",
    casetitle: "P-32   十二指腸異所性膵から発生した膵癌の1例",
    reader:"前川　有里（がん研究会有明病院　肝胆膵内科）",
    members: `○前川 有里<sup>1）</sup>、三重 尭文<sup>1）</sup>、小野 嘉大<sup>2）</sup>、高松 学<sup>3）</sup>、森 健作<sup>4）</sup>、岡本 武士<sup>1）</sup>、武田 剛志<sup>1）</sup>、佐々木 隆<sup>1）</sup>、尾阪 将人<sup>1）</sup>、笹平 直樹<sup>1）</sup>
1）がん研究会有明病院 肝胆膵内科、2）がん研究会有明病院 肝胆膵外科、
3）がん研究会有明病院 病理診断部、4）がん研究会有明病院 画像診断部
`,
    detail: `　57 歳男性。胆石症に対し胆嚢摘出後 (40 歳 )、右肺良性腫瘍に対し部分切除後 (53 歳 )。検診にて
CA19-9 高値を指摘され当院を受診した。自覚症状は認めなかった。造影 CT では当初明らかな病変は指摘し得なかったが、PET-CT にて胆嚢管断端近傍に SUV max 8.1 の集積を認めた。後方視的に造影 CT を再検したところ、十二指腸球部腹側に遅延性に造影される 26mm 大の腫瘤を認めた。MRI では十二指腸球部腹側に拡散制限を伴う腫瘤を認めた。上部消化管内視鏡検査では上十二指腸角に発赤を伴う粘膜下腫瘍様隆起を認めたが、明らかな上皮性病変は認めなかった。EUS では十二指腸粘膜下に内部不整な低エコー腫瘤を認めた。膵および遺残胆嚢管と同病変に明らかな連続性を認めなかった。同病変に対して EUS-FNA を施行し、腺癌の診断に至った。十二指腸癌、異所性膵癌などが鑑別としてあがった。明らかな転移を認めず、診断的治療として膵頭十二指腸切除を施行した。術後病理では十二指腸壁内から腹側の脂肪組織内に主座をおく30mm 大の中分化型管状腺癌を認めた。周囲には膵管様の非腫瘍性拡張腺管や Langerhans 島が散在していた。膵実質に原発巣を認めないことから異所性膵から発生した膵癌の診断に至った。
【検討事項】
・術前の画像所見で異所性膵癌と診断できるポイントはあったか。
・FNA にて正常膵組織は検出できたのか。
`,
    link: "/case/p-32",
  },
  {
    caseid: "p-33",
    sessionid:"057",
    title: "11：00〜11：50　ポスター口演　［ Poster 10 ］（P-32〜P-34）",
    casetitle: "P-33   術前にGISTが疑われた十二指腸乳頭部腫瘍に対して手術を施行し病理学的に十二指腸神経鞘腫と診断された一例",
    reader:"森　弘帆（自治医科大学附属さいたま医療センター）",
    members: `○森 弘帆、遠藤 裕平、前村 公也、水澤 由樹、市田 晃佑、渡部 文昭、力山 敏樹
自治医科大学附属さいたま医療センター
`,
    detail: `　症例は 47 歳女性、背部痛を主訴に近医受診し、腹部超音波検査で腹部腫瘤が指摘された。CT で十二指
腸球部に潰瘍性病変と造影効果を伴う 50mm の腫瘤性病変あり、EOB MRI で同部位に T2 で不均一な高信号と拡散強調で抑制を示す腫瘤性病変を認めた。PET CT で膵頭部に 50mm の SUV max8.60 集積していた。上部消化管内視鏡で十二指腸角部に表面平滑な陥凹性病変を認め、生検では腫瘍細胞は検出されなかった。以上の画像所見から GIST が疑われたため、亜全胃温存膵頭十二指腸切除術、D1 リンパ節郭清を施行した。術後 19 日目に独歩退院となった。膵頭十二指腸切除検体の病理所見は、組織学的に異型の乏しい紡錘形細胞が不規則に錯綜して増殖しており上皮の開口部付近では壊死や嚢胞性変化を認めた。 紡錘形細胞について、免疫組織学的に CD34 陰性、c-kit 陰性、DCG1 陰性、Desmin 陰性、S100 陽性で、Ki-67 標識率は1-2% であった。以上より、形態と合わせて膵神経鞘腫と診断された。膵神経鞘腫は非常に稀な腫瘍であり、特徴的な臨床症状が無く多彩な画像所見を認めることから術前診断は困難であるとされる。術前に診断し得なかった十二指腸神経鞘腫に対して根治的手術を施行した症例を経験したので、画像診断学的観点から文献学的考察を含めて報告する。
`,
    link: "/case/p-33",
  },
  {
    caseid: "p-34",
    sessionid:"058",
    title: "11：00〜11：50　ポスター口演　［ Poster 10 ］（P-32〜P-34）",
    casetitle: "P-34   リンパ節転移をきたした小型十二指腸乳頭部NET G1の1例",
    reader:"児島　一成（鹿児島大学大学院 消化器疾患・生活習慣病学）",
    members: `○児島 一成<sup>1）</sup>、橋元 慎一<sup>1）</sup>、山里 侑<sup>1）</sup>、板山 雄亮<sup>1）</sup>、樋之⼝ 真<sup>1）</sup>、田ノ上 史郎<sup>1）</sup>、大塚 隆生<sup>2）</sup>
1）鹿児島大学大学院 消化器疾患・生活習慣病学、2）鹿児島大学大学院 消化器外科学
`,
    detail: `　症例は 66 歳女性。健康診断で施行された上部消化管内視鏡検査で、十二指腸主乳頭に 10mm 大の中央陥
凹を有する粘膜下腫瘍様の隆起性病変を認めた。病変陥凹部の生検で神経内分泌腫瘍 (NET) G1 と診断され、当科紹介となった。超音波内視鏡検査 (EUS) で、第 2-3 層を主座とする、類円形の 8mm 大の低エコー病変として描出され、明らかな筋層、胆管や膵管への浸潤所見を認めなかった。乳頭部は造影 CT で造影される結節、MRI では拡散制限を伴う結節として同定され、明らかな膵浸潤はなく、リンパ節転移や遠隔転移は指摘できなかった。また、オクトレオスキャンでは乳頭部を含め、明らかな集積を認めなかった。ガイドライン上は手術が推奨されるが、低 Grade、かつ筋層、胆管や膵管への浸潤所見を認めないことから、外科との協議及び患者への十分な IC の上、内視鏡的乳頭切除術を施行した。病理結果は NET G1 であり、深部断端が陽性で、リンパ管侵襲を認めたことから膵頭十二指腸切除を施行した。病理結果は、切除部に遺残を認めなかったが、#17 リンパ節の転移を認めた。術後 2 年経過するが、再発なく経過している。小型十二指腸乳頭部 NET G1 でもリンパ節転移をきたした症例であり、慎重な治療方針の検討が必要である。
`,
    link: "/case/p-34",
  },
]


export default Cases;